/**
 * EMTAK activity CLASSES (the third filter level) - generated from the business
 * register's open data (ArEntity.emtak plus emtakText), grouped by 2-digit
 * division. Each entry is { v: comma-separated EMTAK codes, used as prefixes by
 * the backend, l: the activity name }. One name can cover several version codes
 * (a 2008 revision next to an older one), so `v` is OR-ed on the backend with
 * startsWith. DO NOT edit by hand - regenerate it with the query described in
 * the emtak.ts header.
 */
export interface EmtakActivity {
  /** Comma-separated EMTAK code prefixes. */
  v: string;
  /** Activity name (Estonian). */
  l: string;
}

/** A division's 2-digit code to its activity classes, sorted by name. */
export const EMTAK_ACTIVITIES: Record<string, EmtakActivity[]> = {
  "01": [
    { v: "0143,01431", l: "Hobusekasvatus ja muude hobuslaste kasvatus" },
    { v: "01701", l: "Jahindus ja seda teenindavad tegevusalad" },
    { v: "01271", l: "Joogitaimekasvatus" },
    { v: "01441", l: "Kaamelikasvatus" },
    { v: "01161", l: "Kiutaimekasvatus" },
    { v: "0147,01471", l: "Kodulinnukasvatus" },
    { v: "01131", l: "Köögivilja- (sh kõrvitsaliste), juurvilja- ja mugulviljakasvatus, k.a seenekasvatus" },
    { v: "0113,01131", l: "Köögivilja- ja melonikasvatus, juurvilja- ja mugulviljakasvatus" },
    { v: "0145,01451", l: "Lamba- ja kitsekasvatus" },
    { v: "01191", l: "Lillekasvatus" },
    { v: "0162,01621", l: "Loomakasvatuse abitegevused" },
    { v: "01481,01491", l: "Mesindus" },
    { v: "0148,01489,0149,01499", l: "Muu loomakasvatus" },
    { v: "0125,01251", l: "Muu puuvilja-, marja- ning pähklikasvatus" },
    { v: "0142,01421", l: "Muu veislaste ja pühvlikasvatus" },
    { v: "0129,01291", l: "Muude mitmeaastaste taimede kasvatus" },
    { v: "0119", l: "Muude põllukultuuride kasvatus" },
    { v: "0119", l: "Muude üheaastaste põllukultuuride kasvatus" },
    { v: "01261", l: "Õlitaimekasvatus" },
    { v: "01261", l: "Õliviljade kasvatus" },
    { v: "0124,01241", l: "Õun- ja luuviljaliste puuviljade kasvatus" },
    { v: "0141,01411", l: "Piimakarjakasvatus" },
    { v: "016", l: "Põllumajandust abistavad tegevusalad ja saagikoristusjärgsed tegevused" },
    { v: "0163,01631", l: "Saagikoristusjärgsed tegevused" },
    { v: "0163", l: "Saagikoristusjärgsed tegevused ja seemnete töötlemine paljundamiseks" },
    { v: "01461", l: "Seakasvatus" },
    { v: "01641", l: "Seemnete töötlemine paljundamiseks" },
    { v: "0150,01501", l: "Segapõllumajandus" },
    { v: "01192", l: "Sööda- ja heintaimekasvatus jm üheaastaste põllukultuuride kasvatus" },
    { v: "01199", l: "Söödakultuuri- ja heintaimekasvatus jm üheaastaste põllukultuuride kasvatus" },
    { v: "01301", l: "Taimede paljundamine" },
    { v: "01301", l: "Taimede paljundamine ja istikukasvatus" },
    { v: "0161,01611", l: "Taimekasvatuse abitegevused" },
    { v: "01111", l: "Teravilja- (v.a riis) ja kaunviljakasvatus; õlitaimeseemnete kasvatus" },
    { v: "0111,01111", l: "Teravilja- (v.a riis), kaunvilja- ja õlitaimeseemnete kasvatus" },
    { v: "01221", l: "Troopiliste ja subtroopiliste viljade kasvatus" },
    { v: "011", l: "Üheaastaste põllukultuuride kasvatus" },
    { v: "01211", l: "Viinamarjakasvatus" },
    { v: "0128,01281", l: "Vürtsi-, maitse-, uimastavate taimede ja ravimtaimede kasvatus" },
  ],
  "02": [
    { v: "02202", l: "Küttepuude tootmine" },
    { v: "02301", l: "Looduslike materjalide kogumine, v.a puit" },
    { v: "02301", l: "Loodussaaduste, v.a puidu varumine" },
    { v: "0210,02101", l: "Metsakasvatus ja muud metsamajanduse tegevusalad" },
    { v: "02401", l: "Metsamajandust abistavad tegevused" },
    { v: "02201", l: "Metsaraie" },
    { v: "022,0220,02201", l: "Metsavarumine" },
  ],
  "03": [
    { v: "03301", l: "Kalapüüki ja vesiviljelust abistavad tegevusalad" },
    { v: "03221", l: "Magevee-vesiviljelus" },
    { v: "0312,03121", l: "Mageveekalapüük" },
    { v: "03211", l: "Mere-vesiviljelus" },
    { v: "0311,03111", l: "Merekalapüük" },
  ],
  "06": [
    { v: "06201", l: "Maagaasi tootmine" },
    { v: "06101", l: "Põlevkivi kaevandamine ja toornafta tootmine" },
    { v: "06101", l: "Toornafta tootmine ja põlevkivi kaevandamine" },
  ],
  "07": [
    { v: "07291", l: "Muude mitteraudmetallide maakide kaevandamine" },
  ],
  "08": [
    { v: "0811,08111", l: "Dekoratiiv- ja ehituskivi, lubjakivi, kipsi, kriidi ja kiltkivi kaevandamine" },
    { v: "08111", l: "Dekoratiivkivi, lubjakivi, kipsi, kiltkivi ja muu kivi kaevandamine" },
    { v: "08911", l: "Kemikaalide ja mineraalväetiste toorme kaevandamine" },
    { v: "08122", l: "Killustiku tootmine" },
    { v: "0812,08121", l: "Kruusa- ja liivakarjääride tegevus ning savi ja kaoliini kaevandamine" },
    { v: "0812,08121", l: "Kruusa- ja liivakarjääride tegevus; savi ja kaoliini kaevandamine" },
    { v: "08991", l: "Muu mujal liigitamata kaevandamine" },
    { v: "08921", l: "Turba tootmine" },
  ],
  "09": [
    { v: "0990,09901", l: "Muud kaevandamist abistavad tegevusalad" },
    { v: "09101", l: "Nafta ja maagaasi tootmist abistavad tegevusalad" },
  ],
  "10": [
    { v: "10861", l: "Homogeenitud toiduainete ja dieettoitude tootmine" },
    { v: "10521", l: "Jäätise ja muu toidujää tootmine" },
    { v: "10521", l: "Jäätisetootmine" },
    { v: "1061,10611", l: "Jahu ja tangainete tootmine" },
    { v: "10611", l: "Jahu ja tangainete tootmine, k.a jahvatamine" },
    { v: "10512", l: "Juustu ja kohupiima tootmine" },
    { v: "10512", l: "Juustu- ja kohupiimatootmine" },
    { v: "1082,10821", l: "Kakao, šokolaadi ja suhkrukondiitritoodete tootmine" },
    { v: "10201", l: "Kala, koorikloomade ja molluskite töötlemine ja säilitamine" },
    { v: "10201", l: "Kala, vähilaadsete ja limuste töötlemine ja säilitamine" },
    { v: "10311", l: "Kartuli töötlemine ja säilitamine" },
    { v: "10721", l: "Kuiviku- ja küpsisetootmine; säilitusainetega pagaritoodete tootmine" },
    { v: "10721", l: "Kuivikute, küpsiste, pika realiseerimisajaga pagaritoodete tootmine" },
    { v: "10711", l: "Leiva- ja saiatootmine; lühikese realiseerimisajaga pagaritoodete tootmine" },
    { v: "10711", l: "Leiva- ja saiatootmine; säilitusaineteta pagaritoodete tootmine" },
    { v: "1071", l: "Leivatootmine; säilitusaineteta pagaritoodete tootmine" },
    { v: "10921", l: "Lemmikloomade valmistoidu tootmine" },
    { v: "1011", l: "Liha töötlemine ja säilitamine" },
    { v: "10111", l: "Liha töötlemine ja säilitamine, k.a tapamajade tegevus" },
    { v: "10131", l: "Liha- ja linnulihatoodete tootmine" },
    { v: "10111", l: "Liha, v.a linnuliha, töötlemine ja säilitamine" },
    { v: "10121", l: "Linnuliha töötlemine ja säilitamine, k.a sulgede tootmine" },
    { v: "10841", l: "Maitseainete ja -kastmete tootmine" },
    { v: "1073,10731", l: "Makaronide, nuudlite, kuskussi jms makarontoodete tootmine" },
    { v: "1089,10891", l: "Mujal liigitamata toiduainete tootmine" },
    { v: "1039,10391", l: "Muu puu- ja köögivilja töötlemine ja säilitamine" },
    { v: "10519", l: "Muude piimatoodete tootmine, sh või tootmine" },
    { v: "10519", l: "Muude piimatoodete, k.a või tootmine" },
    { v: "10411", l: "Õli ja rasva tootmine" },
    { v: "1051", l: "Piima töötlemine, piimatoodete ja juustu tootmine" },
    { v: "1051", l: "Piimatoodete tootmine" },
    { v: "10321", l: "Puu- ja köögiviljamahla tootmine" },
    { v: "10831", l: "Tee ja kohvi töötlemine" },
    { v: "1091,10911", l: "Valmissööda tootmine loomakasvatusele" },
    { v: "1085,10851", l: "Valmistoitude tootmine" },
    { v: "10511", l: "Värske piima töötlemine, rõõsa koore tootmine" },
  ],
  "11": [
    { v: "11071", l: "Alkoholivaba joogi ja villitud vee tootmine" },
    { v: "11071", l: "Alkoholivaba joogi tootmine; mineraalvee ja muu villitud vee tootmine" },
    { v: "11011", l: "Kange alkoholi destilleerimine, rektifitseerimine ja segamine" },
    { v: "11041", l: "Muude destilleerimata kääritatud jookide tootmine" },
    { v: "11051", l: "Õlletootmine" },
    { v: "1103,11031", l: "Siidri ja muu marja- ja puuviljaveini tootmine" },
    { v: "11031", l: "Siidri ja muude marjadest ja puuviljadest kääritatud jookide tootmine" },
    { v: "11021", l: "Viinamarjaveini tootmine" },
  ],
  "12": [
    { v: "12001", l: "Tubakatoodete tootmine" },
  ],
  "13": [
    { v: "13921", l: "Kodutekstiili tootmine, sh voodipesu, köögirätikud, kardinad, akna sisekatted jm eesriided" },
    { v: "1392", l: "Kodutekstiilide ja valmis sisustustarvete tootmine" },
    { v: "13921", l: "Kodutekstiilide, nt voodipesu, rätikute, kardinate jms tootmine" },
    { v: "13951", l: "Lausriide ja lausriidest toodete tootmine" },
    { v: "1395,13951", l: "Lausriide ja lausriidest toodete tootmine, v.a rõivad" },
    { v: "1399,13991", l: "Mujal liigitamata tekstiilitootmine" },
    { v: "13991", l: "Mujal liigitamata tekstiilitootmine, sh kaunistusnööri-, tülli-, pitsi-, paela- ja tikanditootmine" },
    { v: "13929", l: "Muude valmis tekstiiltoodete tootmine" },
    { v: "13941", l: "Nööri, köie ja võrgulina tootmine" },
    { v: "1320,13201", l: "Riidekudumine" },
    { v: "1391,13911", l: "Silmkoe- ja heegelkanga (trikookanga) tootmine" },
    { v: "13961", l: "Tehnilise ja tööstusliku otstarbega tekstiilide tootmine" },
    { v: "1330,13301", l: "Tekstiili viimistlemine" },
    { v: "13201", l: "Tekstiilikudumine" },
    { v: "1310,13101", l: "Tekstiilkiudude ettevalmistamine ja ketramine" },
    { v: "13931", l: "Vaipade ja vaipkatete tootmine" },
    { v: "1392", l: "Valmis tekstiiltoodete tootmine, v.a rõivad" },
  ],
  "14": [
    { v: "1414,14221", l: "Alusrõivaste tootmine" },
    { v: "14141", l: "Alusrõivaste tootmine, sh T-särkide, päevasärkide, hommikumantlite, öösärkide jms tootmine" },
    { v: "14201", l: "Karusnahatoodete tootmine (v.a mütsid ja kindad)" },
    { v: "14199,1429,14299", l: "Muude mujal liigitamata rõivaste ja rõivalisandite tootmine" },
    { v: "1413", l: "Muude pealisrõivaste tootmine" },
    { v: "14131", l: "Muude pealisrõivaste tootmine, k.a rätsepatöö" },
    { v: "1419", l: "Muude rõivaste ja rõivalisandite tootmine" },
    { v: "1439", l: "Muude silmkoe- ja heegelrõivaste tootmine" },
    { v: "14391", l: "Muude silmkoe- ja heegelrõivaste tootmine, nt pulloverid, kampsunid jms tooted" },
    { v: "14241", l: "Nahast ja karusnahast rõivaste tootmine" },
    { v: "14111", l: "Nahkrõivaste tootmine" },
    { v: "14191,14291", l: "Peakatete valmistamine, k.a karusnahast" },
    { v: "14211", l: "Pealisrõivaste tootmine" },
    { v: "14101", l: "Silmkoe- ja heegelrõivaste tootmine" },
    { v: "14311", l: "Suka- ja sokitootmine" },
    { v: "1412,14121,14231", l: "Töörõivaste tootmine" },
  ],
  "15": [
    { v: "15201", l: "Jalatsitootmine" },
    { v: "15121", l: "Kohvrite, käekottide jms kaupade tootmine" },
    { v: "1512", l: "Kohvrite, käekottide, sadulsepatoodete, rakmete jms tootmine" },
    { v: "1512", l: "Mis tahes materjalist kohvrite, käekottide, sadulsepatoodete ja rakmete tootmine" },
    { v: "15129", l: "Muude nahktoodete ja mistahes materjalist sarnaste toodete tootmine" },
    { v: "15129", l: "Muude nahktoodete tootmine" },
    { v: "15111", l: "Naha ja karusnaha parkimine, töötlemine ja värvimine" },
    { v: "15111", l: "Nahatöötlemine ja -parkimine; karusnaha töötlemine ja värvimine" },
    { v: "15122", l: "Sadulsepatoodete tootmine (sadulad, hobuserakmed jm)" },
  ],
  "16": [
    { v: "1623", l: "Ehituspuusepa- ja tisleritoodete tootmine" },
    { v: "16232", l: "Kokkupandavate puitehitiste (saunad, suvilad, majad) ja nende elementide tootmine" },
    { v: "16231", l: "Kokkupandavate puitehitiste ja nende elementide tootmine" },
    { v: "16282,16292", l: "Korgist, õlest ja punumismaterjalist toodete tootmine" },
    { v: "16239", l: "Muude ehituspuusepa- ja tisleritoodete tootmine" },
    { v: "16109", l: "Muude puidutöötlemissaaduste tootmine, sh hakkepuit, puitvill jms" },
    { v: "16219", l: "Muude puitplaatide tootmine" },
    { v: "1628", l: "Muude puittoodete ning korgist, õlest vm punumismaterjalist toodete tootmine" },
    { v: "1629", l: "Muude puittoodete tootmine; korgist, õlest ja punumismaterjalist toodete tootmine" },
    { v: "16102", l: "Puidu kuivatus, immutamine ja keemiline töötlus" },
    { v: "161,1610,16111", l: "Puidu saagimine ja hööveldamine" },
    { v: "16121", l: "Puidu töötlemine ja viimistlemine" },
    { v: "16281,16291", l: "Puidust tarbe- ja dekoratiivesemete jm puittoodete tootmine" },
    { v: "16231", l: "Puidust uste, akende, aknaluukide ja nende raamide tootmine (k.a väravad)" },
    { v: "16212", l: "Puitlaast- ja puitkiudplaadi tootmine" },
    { v: "16212", l: "Puitlaast- ja puitkiudplaatide tootmine" },
    { v: "16241", l: "Puittaara ja puitaluste tootmine" },
    { v: "1624", l: "Puittaara tootmine" },
    { v: "16271", l: "Puittoodete viimistlemine" },
    { v: "16251", l: "Puituste ja -akende tootmine" },
    { v: "16101", l: "Saematerjali tootmine" },
    { v: "1621", l: "Spooni ja puitplaatide tootmine" },
    { v: "16211", l: "Spooni ja vineeri tootmine" },
    { v: "16261", l: "Taimsest biomassist tahkekütuste tootmine" },
  ],
  "17": [
    { v: "1721,17211", l: "Lainepaberi ja -papi ning paber- ja papptaara tootmine" },
    { v: "17251,17291", l: "Muude paber- ja papptoodete tootmine" },
    { v: "17121", l: "Paberi- ja papitootmine" },
    { v: "17111", l: "Paberimassi tootmine" },
    { v: "17231", l: "Paberist kirjatarvete tootmine" },
    { v: "17221", l: "Paberist kodu- ja hügieenitarvete ning tualettpaberi tootmine" },
    { v: "17221", l: "Paberist kodu- ja hügieenitarvete, k.a tekstiilvati ja vatist toodete tootmine" },
    { v: "17241", l: "Tapeeditootmine" },
  ],
  "18": [
    { v: "18111", l: "Ajalehtede trükkimine" },
    { v: "18141", l: "Köitmine ja selle sidusalad" },
    { v: "18129", l: "Mujal liigitamata trükkimine, k.a siiditrükk" },
    { v: "1812", l: "Muu trükkimine" },
    { v: "18122", l: "Perioodikaväljaannete, ärikataloogide, reklaammaterjalide, äriblankettide jm kontoritarvete trükkimine" },
    { v: "18122", l: "Perioodikaväljaannete, reklaammaterjalide, blankettide jms trükkimine" },
    { v: "18121", l: "Raamatute trükkimine" },
    { v: "1820,18201", l: "Salvestiste paljundus" },
    { v: "18131", l: "Trükieelne tegevus" },
  ],
  "19": [
    { v: "19201", l: "Puhastatud naftatoodete (sh turbabriketi) tootmine" },
    { v: "19201", l: "Puhastatud naftatoodete ja fossiilkütusetoodete tootmine" },
  ],
  "20": [
    { v: "20531,20593", l: "Eeterlike õlide tootmine" },
    { v: "20511,20591", l: "Lõhkeaine tootmine" },
    { v: "2059,20591,20599", l: "Mujal liigitamata keemiatoodete tootmine" },
    { v: "20141", l: "Muude orgaaniliste põhikemikaalide tootmine" },
    { v: "20421", l: "Parfüümide ja tualetitarvete tootmine" },
    { v: "20161", l: "Plasti tootmine algkujul" },
    { v: "20411", l: "Seebi, pesemis-, puhastus- ja poleervahendite tootmine" },
    { v: "20171", l: "Sünteeskautšuki (toorkummi) tootmine algkujul" },
    { v: "20201", l: "Taimekaitsevahendite ja muude agrokeemiatoodete tootmine" },
    { v: "20201", l: "Taimekaitsevahendite, desinfektsioonivahendite ja muude agrokeemiatoodete tootmine" },
    { v: "20111", l: "Tööstusgaaside tootmine" },
    { v: "20151", l: "Väetiste ja lämmastikuühendite tootmine" },
    { v: "20301", l: "Värvide, lakkide ja muude viimistlusvahendite ning trükivärvide ja mastiksite tootmine" },
    { v: "20511", l: "Vedelate biokütuste tootmine" },
  ],
  "21": [
    { v: "21101", l: "Põhifarmaatsiatoodete tootmine" },
    { v: "21201", l: "Ravimite jm farmaatsiatoodete tootmine" },
    { v: "21201", l: "Ravimpreparaatide tootmine" },
  ],
  "22": [
    { v: "22191", l: "Kummiplaatide, -lehtede, -torude, -voolikute jms tootmine" },
    { v: "22111", l: "Kummirehvide ja sisekummide tootmine; kummirehvide protekteerimine ja taastamine" },
    { v: "22111", l: "Kummirehvide tootmine, protekteerimine ja taastamine ning sisekummide tootmine" },
    { v: "22199", l: "Mujal liigitamata kummitoodete tootmine" },
    { v: "22121,2219", l: "Muude kummitoodete tootmine" },
    { v: "22239,22249", l: "Muude plastist ehitustoodete tootmine" },
    { v: "22261,2229,22291", l: "Muude plasttoodete tootmine" },
    { v: "2223,2224", l: "Plastist ehitustoodete tootmine" },
    { v: "22231", l: "Plastist sanitaarseadmete tootmine (vannid, kraanikausid jne)" },
    { v: "22241", l: "Plastist sanitaartoodete tootmine (vannid, kraanikausid jne)" },
    { v: "22211", l: "Plastplaatide, -lehtede, -profiilide, -torude, -voolikute, -liitmike jms toodete tootmine" },
    { v: "22211", l: "Plastplaatide, -lehtede, -torude ja -profiilide tootmine" },
    { v: "22221", l: "Plasttaara tootmine" },
    { v: "22251", l: "Plasttoodete töötlemine ja viimistlemine" },
    { v: "22231,22232", l: "Plastuste, -akende, -vaheseinte jms tootmine" },
  ],
  "23": [
    { v: "23911", l: "Abrasiivtoodete tootmine" },
    { v: "2361", l: "Betoonist ehitustoodete tootmine" },
    { v: "23619", l: "Betoonist muude ehitustoodete tootmine" },
    { v: "23703,23709", l: "Graniidist, marmorist jm looduslikust kivist toodete tootmine" },
    { v: "23311", l: "Keraamiliste kivide ja plaatide tootmine" },
    { v: "23421", l: "Keraamiliste sanitaarseadmete tootmine" },
    { v: "23621", l: "Kipsist ehitustoodete tootmine" },
    { v: "23651", l: "Kiudtsemendi tootmine" },
    { v: "2370", l: "Kivilõikamine, -vormimine ja -viimistlus" },
    { v: "2313", l: "Klaasanumate tootmine" },
    { v: "23151,23191", l: "Klaasist ehitusmaterjalide tootmine" },
    { v: "23141", l: "Klaaskiutootmine" },
    { v: "23131", l: "Klaasnõude (v.a klaastaara) ja sisekujunduses vm kasutatavate klaasesemete tootmine" },
    { v: "23131", l: "Klaasnõude jm sisekujunduses kasutatavate klaasesemete tootmine" },
    { v: "23132", l: "Klaastaara tootmine" },
    { v: "23411", l: "Kodu- ja ehiskeraamika tootmine" },
    { v: "23611", l: "Kokkupandavate betoonehitiste ja nende elementide tootmine" },
    { v: "23121", l: "Lehtklaasi vormimine ja töötlemine" },
    { v: "23701", l: "Looduskivist hauakivide, -plaatide jms valmistamine" },
    { v: "23521", l: "Lubja- ja kipsitootmine" },
    { v: "23641", l: "Mörditootmine" },
    { v: "23991", l: "Mujal liigitamata muude mittemetalsetest mineraalidest toodete tootmine" },
    { v: "23451,23491", l: "Muu keraamika tootmine" },
    { v: "2315,2319", l: "Muu klaasi tootmine ja töötlemine, sh tehniline klaas" },
    { v: "2369,23691", l: "Muude betoon-, kips- ja tsementtoodete tootmine" },
    { v: "23661", l: "Muude betoon-, tsement- ja kipstoodete tootmine" },
    { v: "23159,23199", l: "Muude klaastoodete ja tehnilise klaasi tootmine" },
    { v: "23702", l: "Paekivist ja dolomiidist ehitusmaterjalide jm toodete tootmine" },
    { v: "23321", l: "Põletatud savist telliste, kivide ja muude ehitustoodete tootmine" },
    { v: "23511", l: "Tsemenditootmine" },
    { v: "23201", l: "Tulekindlate toodete tootmine" },
    { v: "23631", l: "Valmis betoonisegu tootmine" },
  ],
  "24": [
    { v: "24421", l: "Alumiiniumitootmine" },
    { v: "24531", l: "Kergmetallide valu" },
    { v: "24331", l: "Külmvormimine ja -painutamine" },
    { v: "24511", l: "Malmivalu" },
    { v: "24451", l: "Muude mitteraudmetallide tootmine" },
    { v: "24541", l: "Muude mitteraudmetallide valu" },
    { v: "24431", l: "Plii-, tsingi- ja tinatootmine" },
    { v: "24101", l: "Raua, terase ja ferrosulamite tootmine" },
    { v: "24201", l: "Terastorude, -õõnesprofiilide jms -toruliitmike tootmine" },
    { v: "24411", l: "Väärismetallitootmine" },
  ],
  "25": [
    { v: "25301", l: "Aurukatelde tootmine, v.a keskkütte-kuumaveekatlad" },
    { v: "25921", l: "Kergmetalltaara tootmine" },
    { v: "25211", l: "Keskkütteradiaatorite, aurukatelde ja kuumaveekatelde tootmine" },
    { v: "25941", l: "Kinnituselementide ja keermestatud toodete tootmine" },
    { v: "25111", l: "Kokkupandavate metallehitiste tootmine" },
    { v: "25611,25711", l: "Lõike- ja söögiriistade tootmine" },
    { v: "25621", l: "Lukkude ja hingede tootmine" },
    { v: "25531,2562,25621", l: "Mehaaniline metallitöötlus" },
    { v: "25401", l: "Metalli sepistamine ja vormimine ning pulbermetallurgia" },
    { v: "2550,25501", l: "Metalli sepistamine, pressimine, stantsimine ja rullvaltsimine; pulbermetallurgia" },
    { v: "25521", l: "Metallide kuumtöötlemine" },
    { v: "2561,25611", l: "Metallitöötlus ja metallpindade katmine" },
    { v: "2511", l: "Metallkonstruktsioonide ja nende osade tootmine" },
    { v: "25511", l: "Metallpindade katmine" },
    { v: "25121", l: "Metalluste ja -akende tootmine" },
    { v: "2599,25991", l: "Mujal liigitamata metalltoodete tootmine" },
    { v: "25119", l: "Muude metallkonstruktsioonide ja nende osade tootmine" },
    { v: "25221,25291", l: "Muude metallpaakide, -reservuaaride ja -mahutite tootmine" },
    { v: "25739", l: "Muude tööriistade tootmine" },
    { v: "25301,25401", l: "Relva- ja laskemoonatootmine" },
    { v: "25911", l: "Terasvaatide jms mahutite tootmine" },
    { v: "25631,2573", l: "Tööriistade tootmine" },
    { v: "25931", l: "Traaditoodete, kettide ja vedrude tootmine" },
    { v: "25731", l: "Valuvormide tootmine" },
  ],
  "26": [
    { v: "26521", l: "Ajanäitajate tootmine" },
    { v: "26201", l: "Arvutite ja arvuti välisseadmete tootmine" },
    { v: "26111", l: "Elektronkomponentide tootmine" },
    { v: "26601", l: "Kiiritus-, elektromeditsiini- ja elektroteraapiaseadmete tootmine" },
    { v: "26801", l: "Magnetandmekandjate ja optiliste andmekandjate tootmine" },
    { v: "26511", l: "Mõõte-, katse- ja navigatsiooniseadmete tootmine" },
    { v: "26701", l: "Optikainstrumentide ja fotoseadmete tootmine" },
    { v: "26701", l: "Optikainstrumentide, magnet- ja optiliste andmekandjate ning fotoseadmete tootmine" },
    { v: "26301", l: "Sideseadmete tootmine" },
    { v: "2640,26401", l: "Tarbeelektroonika tootmine" },
    { v: "26121", l: "Trükkplaatide tootmine" },
  ],
  "27": [
    { v: "27121", l: "Elektrijaotusseadmete ja juhtaparatuuri tootmine" },
    { v: "27401", l: "Elektriliste ja mitte elektriliste valgustite tootmine" },
    { v: "27511", l: "Elektriliste kodumasinate tootmine" },
    { v: "27111", l: "Elektrimootorite, -generaatorite ja trafode tootmine" },
    { v: "27331", l: "Juhtmestiku tarvikute tootmine" },
    { v: "27311", l: "Kiudoptilise kaabli tootmine" },
    { v: "27521", l: "Mitteelektriliste kodumasinate tootmine" },
    { v: "27321", l: "Muu elektroonika ja elektrijuhtme või -kaabli tootmine" },
    { v: "27321", l: "Muu elektroonika- ja elektrijuhtmete või -kaabli tootmine" },
    { v: "27901", l: "Muude elektriseadmete tootmine" },
    { v: "27201", l: "Patareide ja akude tootmine" },
    { v: "27401", l: "Valgustusseadmete tootmine" },
  ],
  "28": [
    { v: "28211", l: "Ahjude, tööstusahjude ja ahjupõletite tootmine" },
    { v: "28211", l: "Ahjude, tööstusahjude ja kodumajapidamises kasutatavate püsikütteseadmete tootmine" },
    { v: "28241", l: "Ajamiga käsi-tööriistade tootmine" },
    { v: "28121", l: "Hüdrauliliste ja pneumaatiliste jõuseadmete tootmine" },
    { v: "28921", l: "Kaevandus-, karjääri- ja ehitusmasinate tootmine" },
    { v: "28231", l: "Kontorimasinate ja -seadmete tootmine, v.a arvutid ja arvuti välisseadmed" },
    { v: "28151", l: "Laagrite, ajamite, hammasülekannete ja ülekandeelementide tootmine" },
    { v: "28411", l: "Metallistantside ja muude metallitööpinkide tootmine" },
    { v: "28911", l: "Metallurgiamasinate tootmine" },
    { v: "28302", l: "Metsamajandusmasinate tootmine" },
    { v: "28111", l: "Mootorite ja turbiinide tootmine, v.a õhu- ja mootorsõidukite ning mootorrataste mootorid" },
    { v: "28111", l: "Mootorite ja turbiinide tootmine, v.a õhusõidukite, mootorsõidukite ja mootorrataste mootorid" },
    { v: "2899,28991", l: "Mujal liigitamata erimasinate tootmine" },
    { v: "2829,28291", l: "Mujal liigitamata üldmasinate ja mehhanismide tootmine" },
    { v: "28141", l: "Muude kraanide ja ventiilide tootmine" },
    { v: "28131", l: "Muude pumpade ja kompressorite tootmine" },
    { v: "28421,28491", l: "Muude tööpinkide tootmine" },
    { v: "28951", l: "Paberi- ja papitööstusmasinate tootmine" },
    { v: "28961", l: "Plasti- ja kummitööstusmasinate tootmine" },
    { v: "2830,28301", l: "Põllu- ja metsamajandusmasinate tootmine" },
    { v: "28301", l: "Põllumajandusmasinate tootmine" },
    { v: "28941", l: "Tekstiili-, rõiva- ja nahatööstusmasinate tootmine" },
    { v: "28931", l: "Toiduaine-, joogi- ja tubakatööstusmasinate tootmine" },
    { v: "28251", l: "Tööstuslike kliimaseadmete tootmine" },
    { v: "28251", l: "Tööstuslike külmutus- ja ventilatsiooniseadmete tootmine" },
    { v: "28221", l: "Tõste- ja teisaldusseadmete tootmine" },
  ],
  "29": [
    { v: "29202", l: "Haagiste, poolhaagiste ning konteinerite tootmine" },
    { v: "29201", l: "Mootorsõidukikerede tootmine" },
    { v: "2920", l: "Mootorsõidukikerede tootmine; haagiste ja poolhaagiste tootmine" },
    { v: "29311", l: "Mootorsõidukite elektri- ja elektroonikaseadmete tootmine" },
    { v: "2932,29321", l: "Mootorsõidukite muude osade ja lisaseadmete tootmine" },
    { v: "29101", l: "Mootorsõidukite tootmine" },
  ],
  "30": [
    { v: "30921", l: "Jalgrataste ja invasõidukite tootmine" },
    { v: "30111", l: "Laevade ehitus" },
    { v: "3011", l: "Laevade ja ujuvkonstruktsioonide ehitus" },
    { v: "3012,30121", l: "Lõbusõidu- ja sportpaatide ehitus" },
    { v: "30321", l: "Militaarõhusõidukite ja -kosmosesõidukite jms seadmete tootmine" },
    { v: "30401", l: "Militaarveokite tootmine" },
    { v: "30911", l: "Mootorrataste tootmine" },
    { v: "30991", l: "Muude mujal liigitamata transpordivahendite tootmine" },
    { v: "3030,30301", l: "Õhu- ja kosmosesõidukite jms tootmine" },
    { v: "30201", l: "Raudteevedurite ja -veeremi tootmine" },
    { v: "30131", l: "Sõjalaevade ehitus" },
    { v: "30111", l: "Tsiviillaevade ehitus" },
    { v: "3011", l: "Tsiviillaevade ja -ujuvkonstruktsioonide ehitus" },
    { v: "30311", l: "Tsiviilõhusõidukite ja -kosmosesõidukite jms seadmete tootmine" },
    { v: "30112", l: "Tsiviilotstarbeliste ujuvkonstruktsioonide ehitus" },
    { v: "30112", l: "Ujuvkonstruktsioonide ehitus" },
  ],
  "31": [
    { v: "3101,31011", l: "Kontori- ja kauplusemööbli tootmine" },
    { v: "3102,31021", l: "Köögimööbli tootmine" },
    { v: "31002,31031", l: "Madratsitootmine" },
    { v: "31001", l: "Mööbli (v.a madratsite) tootmine" },
    { v: "31092", l: "Mööbliosade tootmine" },
    { v: "31,3100", l: "Mööblitootmine" },
    { v: "31091", l: "Mujal liigitamata mööbli tootmine" },
    { v: "3109", l: "Muu mööbli tootmine" },
  ],
  "32": [
    { v: "32501", l: "Hambaraviinstrumentide ning materjalide tootmine" },
    { v: "32911", l: "Harja-, pintsli- ja luuatootmine" },
    { v: "32131", l: "Juveeltoodete imitatsioonide jms toodete tootmine" },
    { v: "32131", l: "Juveeltoodete imitatsioonide jms tootmine" },
    { v: "3240,32401", l: "Mängude ja mänguasjade tootmine" },
    { v: "3250", l: "Meditsiini- ja hambaraviinstrumentide ning materjalide tootmine" },
    { v: "32509", l: "Muu meditsiini- ja hambaraviinstrumentide ning materjalide tootmine" },
    { v: "3299,32991", l: "Muu mujal liigitamata tootmine" },
    { v: "32509", l: "Muude meditsiiniinstrumentide ning materjalide tootmine" },
    { v: "32201", l: "Muusikariistade tootmine" },
    { v: "32502", l: "Prillide, läätsede ja nende osade tootmine" },
    { v: "32301", l: "Sporditarvete tootmine" },
    { v: "32501", l: "Toimetulekut parandavate ja edendavate mehaaniliste abivahendite tootmine" },
    { v: "32121", l: "Väärisesemete jms toodete tootmine" },
  ],
  "33": [
    { v: "33141", l: "Elektriseadmete remont" },
    { v: "3313,33131", l: "Elektroonika- ja optikaseadmete remont" },
    { v: "33131", l: "Elektroonika- ja optikaseadmete remont ja hooldus" },
    { v: "33151", l: "Laevade ja paatide remont ja hooldus" },
    { v: "33121", l: "Masinate ja seadmete remont" },
    { v: "33121", l: "Masinate ja seadmete remont ning hooldus" },
    { v: "3311,33111", l: "Metalltoodete remont" },
    { v: "33111", l: "Metalltoodete remont ja hooldus" },
    { v: "33181", l: "Militaarveokite, -laevade, -paatide, -õhusõidukite ja -kosmosesõidukite remont ja hooldus" },
    { v: "33141", l: "Muude elektriseadmete remont ja hooldus" },
    { v: "33191", l: "Muude seadmete remont" },
    { v: "33191", l: "Muude seadmete remont ja hooldus" },
    { v: "3317,33171", l: "Muude transpordivahendite remont ja hooldus" },
    { v: "33171", l: "Muude tsiviiltranspordivahendite remont ja hooldus" },
    { v: "33161", l: "Õhu- ja kosmosesõidukite remont ja hooldus" },
    { v: "3320,33201", l: "Tööstuslike masinate ja seadmete paigaldus" },
    { v: "33151", l: "Tsiviillaevade ja -paatide remont ja hooldus" },
    { v: "33161", l: "Tsiviilõhusõidukite ja -kosmosesõidukite remont ja hooldus" },
  ],
  "35": [
    { v: "35301", l: "Auru ja konditsioneeritud õhuga varustamine" },
    { v: "35212", l: "Biogaasi tootmine" },
    { v: "35401", l: "Elektrienergia ja maagaasi maaklerite ja vahendajate tegevus" },
    { v: "3513,35131,35141", l: "Elektrienergia jaotus" },
    { v: "3514,35141,35151", l: "Elektrienergia müük" },
    { v: "35161", l: "Elektrienergia salvestamine" },
    { v: "3511", l: "Elektrienergia tootmine" },
    { v: "35112,35121", l: "Elektrienergia tootmine hüdroenergiast" },
    { v: "35111", l: "Elektrienergia tootmine mittetaastuvast energiaallikast" },
    { v: "35123", l: "Elektrienergia tootmine päikeseenergiast" },
    { v: "35111", l: "Elektrienergia tootmine taastumatutest energiaallikatest" },
    { v: "3512", l: "Elektrienergia tootmine taastuvatest energiaallikatest" },
    { v: "35113,35122", l: "Elektrienergia tootmine tuuleenergiast" },
    { v: "35121,35131", l: "Elektrienergia ülekanne" },
    { v: "35211", l: "Gaasi (v.a biogaasi) tootmine" },
    { v: "35241", l: "Gaasi hoiustamine võrgutarneteenuse osana" },
    { v: "35231", l: "Gaasimüük magistraalvõrkude kaudu" },
    { v: "35211", l: "Gaasitootmine" },
    { v: "35221", l: "Gaaskütuste jaotus magistraalvõrkude kaudu" },
    { v: "35221", l: "Maagaasi ülekanne ja jaotus maagaasivõrgu kaudu" },
    { v: "35119", l: "Muu elektrienergia tootmine (sh biomassist)" },
    { v: "35129", l: "Muu elektrienergia tootmine, k.a biomassist" },
    { v: "35213", l: "Vesiniku tootmine" },
  ],
  "36": [
    { v: "36002", l: "Olmeveega varustamine" },
    { v: "3600,36001", l: "Veekogumine, -töötlus ja -varustus" },
  ],
  "37": [
    { v: "37001", l: "Kanalisatsioon ja heitveekäitlus" },
  ],
  "38": [
    { v: "38221", l: "Jäätmete kasutamine energia tootmiseks" },
    { v: "38211", l: "Materjalide taaskasutusele võtmine" },
    { v: "38231", l: "Muu jäätmete taaskasutamine" },
    { v: "38121", l: "Ohtlike jäätmete kogumine" },
    { v: "38221", l: "Ohtlike jäätmete töötlus ja kõrvaldus" },
    { v: "38311", l: "Põletamine energia tootmiseta" },
    { v: "38321", l: "Prügilasse ladestamine või püsiv ladustamine" },
    { v: "38321", l: "Sorteeritud materjali taaskasutusele võtmine" },
    { v: "3811,38111", l: "Tavajäätmete kogumine" },
    { v: "38211", l: "Tavajäätmete töötlus ja kõrvaldus" },
    { v: "38311", l: "Vrakkide demonteerimine" },
  ],
  "39": [
    { v: "39001", l: "Saastekäitlus ja muud jäätmekäitlustegevused" },
  ],
  "41": [
    { v: "41001,4120,41201", l: "Elamute ja mitteeluhoonete ehitus" },
    { v: "4110,41101", l: "Hoonestusprojektide arendus" },
  ],
  "42": [
    { v: "4222,42221", l: "Elektri- ja sidevõrkude ehitus" },
    { v: "42212", l: "Kaevude ja puuraukude rajamine ning likvideerimine" },
    { v: "42111", l: "Maanteede ja kiirteede ehitus" },
    { v: "4299,42991", l: "Mujal liigitamata rajatiste ehitus" },
    { v: "42121", l: "Raudteede ja metroo ehitus" },
    { v: "42121", l: "Raudteede ja metroo ehitus, hooldus ja remont" },
    { v: "42131", l: "Silla- ja tunneliehitus" },
    { v: "4211,42111", l: "Teede ja kiirteede ehitus" },
    { v: "4221,42211", l: "Vee-, gaasi- ja kanalisatsioonitrasside ehitus" },
    { v: "42911", l: "Vesiehitus" },
  ],
  "43": [
    { v: "4312", l: "Ehitusplatside ettevalmistus" },
    { v: "43121", l: "Ehitusplatside ettevalmistus ja puhastus" },
    { v: "4332", l: "Ehituspuusepatoodete paigaldus" },
    { v: "4321", l: "Elektriinstallatsioon" },
    { v: "43211", l: "Elektrijuhtmete ja -seadmete paigaldus" },
    { v: "43211", l: "Elektripaigaldustööd" },
    { v: "43501", l: "Eriehitustööd rajatiste ehitusel" },
    { v: "43601", l: "Eriehitustööde vahendusteenus" },
    { v: "43231,43291", l: "Isolatsioonitööd" },
    { v: "43411,4391,43911", l: "Katusetööd" },
    { v: "43131", l: "Kontrollpuurimine ja sondimine" },
    { v: "4331,43311", l: "Krohvimine" },
    { v: "43221", l: "Kütte-, ventilatsiooni- ja kliimaseadmete paigaldus" },
    { v: "43221", l: "Kütte-, ventilatsiooni- ja kliimaseadmete paigaldus, remont ja hooldus" },
    { v: "4311,43111", l: "Lammutamine" },
    { v: "43122", l: "Maakuivendus- ja maaparandustööd" },
    { v: "43122", l: "Maakuivendus- ja maaparandustööd, k.a metsa- ja põllumaade kuivendus" },
    { v: "43321", l: "Mistahes materjalist akende, uste ja treppide paigaldus" },
    { v: "43299", l: "Mujal liigitamata ehituspaigaldustööd" },
    { v: "43351,4339,43391", l: "Muu ehitiste viimistlus ja lõpetamine" },
    { v: "43241,4329", l: "Muud ehituspaigaldustööd" },
    { v: "43999", l: "Muud eriehitustööd" },
    { v: "43421", l: "Muud eriehitustööd hoonete ehitusel" },
    { v: "43129", l: "Muud kaeve- ja mullatööd" },
    { v: "4399", l: "Muud mujal liigitamata eriehitustööd" },
    { v: "43329", l: "Muude ehituspuusepatoodete paigaldus" },
    { v: "43911", l: "Müüritööd" },
    { v: "43223", l: "Pliitide, ahjude ja kaminate ladumine või paigaldamine" },
    { v: "4333,43331", l: "Põranda- ja seinakatete paigaldus" },
    { v: "43992", l: "Pottsepatööd. Ahjude ja kaminate tegemine, k.a tööstuskorstnate ja -ahjude ladumine" },
    { v: "43321", l: "Puidust jm materjalist uste, akende ja treppide paigaldus" },
    { v: "43213", l: "Sidekaablite ja antennide paigaldamine" },
    { v: "43212", l: "Signalisatsioonisüsteemide paigaldamine" },
    { v: "43213", l: "Telekommunikatsioonikaablite ja antennide paigaldus" },
    { v: "43993", l: "Tellingute ja tööplatvormide püstitus ja demonteerimine. Ehitus- ja tõsteseadmete rentimine koos operaatoriga" },
    { v: "43991", l: "Tellingute püstitamine ja demonteerimine, ehitus- ja tõsteseadmete rentimine koos operaatoriga" },
    { v: "4322", l: "Torustiku, kütte- ja kliimaseadmete paigaldus" },
    { v: "43212", l: "Tulekahjualarmide, häire- ja valvesignalisatsiooni paigaldus" },
    { v: "4334,43341", l: "Värvimine ja klaasimine" },
    { v: "43222", l: "Veetorustiku ja sanitaarseadmete paigaldus" },
    { v: "43222", l: "Veetorustiku ja sanitaarseadmete paigaldus, remont ja hooldus" },
    { v: "43991", l: "Vundamendi-, betooni- jm müüritööd" },
  ],
  "45": [
    { v: "45202", l: "Autopesu jms teenindus" },
    { v: "4540,45401", l: "Mootorrataste, nende osade ja lisaseadmete müük, hooldus ja remont" },
    { v: "452,4520,45201", l: "Mootorsõidukite hooldus ja remont" },
    { v: "4531,45311", l: "Mootorsõidukite osade ja lisaseadmete hulgimüük" },
    { v: "4532,45321", l: "Mootorsõidukite osade ja lisaseadmete jaemüük" },
    { v: "4519,45191", l: "Muude mootorsõidukite müük" },
    { v: "4511,45111", l: "Sõiduautode ja väikebusside (täismassiga alla 3,5 t) müük" },
  ],
  "46": [
    { v: "46341", l: "Alkohoolsete jookide hulgimüük" },
    { v: "46501,4651,46511", l: "Arvutite, arvuti välisseadmete ja tarkvara hulgimüük" },
    { v: "4643,46431", l: "Elektriliste kodumasinate hulgimüük" },
    { v: "46692", l: "Elektrimaterjalide, -tarvikute ja -seadmete hulgimüük, sh kaablid" },
    { v: "46643", l: "Elektrimaterjalide, -tarvikute ja -seadmete, k.a kaablite hulgimüük" },
    { v: "46503", l: "Elektroonika- ja sideseadmete ning nende osade hulgimüük" },
    { v: "4652,46521", l: "Elektroonika- ja telekommunikatsiooniseadmete ning nende osade hulgimüük" },
    { v: "46231", l: "Elusloomade hulgimüük" },
    { v: "4646", l: "Farmaatsiatoodete hulgimüük" },
    { v: "4650", l: "Info- ja sidetehnika hulgimüük" },
    { v: "4677", l: "Jäätmete ja jääkide hulgikaubandus" },
    { v: "46771,46871", l: "Jäätmete ja jääkide hulgikaubandus, taara ja pakendite kokkuost" },
    { v: "46422", l: "Jalatsite hulgimüük" },
    { v: "4634", l: "Jookide hulgimüük" },
    { v: "4663,46631", l: "Kaevandus- ja ehitusmasinate hulgimüük" },
    { v: "46322", l: "Kala ja kalatoodete hulgimüük" },
    { v: "46381", l: "Kalade, vähilaadsete ja kalatoodete hulgimüük" },
    { v: "46411", l: "Kangaste, kodutekstiili ja õmblustarvete hulgimüük" },
    { v: "46842", l: "Käsi-tööriistade ja rauakaupade hulgimüük" },
    { v: "4675,4685", l: "Keemiatoodete hulgimüük" },
    { v: "46481", l: "Kellade ja ehete hulgimüük" },
    { v: "46471", l: "Kodu-, kontori- ja kauplusemööbli, vaipade ja valgustite hulgimüük" },
    { v: "46371", l: "Kohvi, tee, kakao ja maitseainete hulgimüük" },
    { v: "46362", l: "Kondiitri- ja pagaritoodete hulgimüük" },
    { v: "46502", l: "Kontorimasinate ja -seadmete hulgimüük" },
    { v: "46651", l: "Kontorimööbli hulgimüük" },
    { v: "46121", l: "Kütuste, maakide, metallide ja tööstuskemikaalide hulgimüügi vahendusteenus" },
    { v: "46121", l: "Kütuste, maakide, metallide ja tööstuskemikaalide vahendamine" },
    { v: "46321", l: "Liha ja lihatoodete hulgimüük" },
    { v: "4632", l: "Liha, lihatoodete, kala ja kalatoodete hulgimüük" },
    { v: "46221", l: "Lillede ja taimede hulgimüük" },
    { v: "46493", l: "Mängude ja mänguasjade hulgimüük" },
    { v: "46141", l: "Masinate, tööstusseadmete, laevade ja õhusõidukite hulgimüügi vahendusteenus" },
    { v: "4614,46141", l: "Masinate, tööstusseadmete, laevade ja õhusõidukite vahendamine" },
    { v: "46462", l: "Meditsiiniseadmete ja kirurgiriistade ning ortopeediliste abivahendite hulgimüük" },
    { v: "4672,46721,46821", l: "Metallide ja metallimaakide hulgimüük" },
    { v: "4619,46191", l: "Mitmesuguste erinevate kaupade vahendamine" },
    { v: "46151", l: "Mööbli, kodutarvete ja rauakaupade hulgimüügi vahendusteenus" },
    { v: "4615,46151", l: "Mööbli, kodutarvete ja rauakaupade vahendamine" },
    { v: "4647,46471", l: "Mööbli, vaipade ja valgustite hulgimüük" },
    { v: "46712,46812", l: "Mootorikütuse hulgimüük" },
    { v: "46731", l: "Mootorrataste, nende osade ja lisaseadmete hulgimüük" },
    { v: "46711", l: "Mootorsõidukite hulgimüük" },
    { v: "46721", l: "Mootorsõidukite osade ja lisaseadmete hulgimüük" },
    { v: "46499", l: "Mujal liigitamata kodutarvete hulgimüük" },
    { v: "46389", l: "Mujal liigitamata toidukaupade hulgimüük" },
    { v: "46891", l: "Muu mujal liigitamata spetsialiseeritud hulgimüük" },
    { v: "46719,46819", l: "Muu vedel- ja gaaskütuse jms hulgimüük" },
    { v: "46342,46349", l: "Muude jookide hulgimüük" },
    { v: "46759,46859", l: "Muude keemiatoodete hulgimüük" },
    { v: "46181", l: "Muude kindlate kaupade hulgimüügi vahendusteenus" },
    { v: "4618,46181", l: "Muude kindlate kaupade vahendamine" },
    { v: "4649", l: "Muude kodutarvete hulgimüük" },
    { v: "46661", l: "Muude kontorimasinate ja -seadmete hulgimüük" },
    { v: "4664,46649,4669", l: "Muude masinate ja seadmete hulgimüük" },
    { v: "46381", l: "Muude toidukaupade hulgimüük" },
    { v: "4638", l: "Muude toidukaupade hulgimüük, k.a kalad, vähilaadsed ja limused" },
    { v: "46699", l: "Muude üld- ja eriotstarbeliste masinate ja seadmete hulgimüük" },
    { v: "4676,46761,46861", l: "Muude vahetoodete hulgimüük" },
    { v: "46491", l: "Paberi, kirjatarvete, raamatute ja ajakirjandusväljaannete hulgimüük" },
    { v: "4645,46451", l: "Parfüümide ja kosmeetika hulgimüük" },
    { v: "4633,46331", l: "Piimatoodete, munade, toiduõli ja -rasva hulgimüük" },
    { v: "46611", l: "Põllumajandusmasinate, -seadmete ja lisaseadmete hulgimüük" },
    { v: "46111", l: "Põllumajandustoorme, elusloomade, tekstiilitoorme ja pooltoodete hulgimüügi vahendusteenus" },
    { v: "4611,46111", l: "Põllumajandustoorme, elusloomade, tekstiilitoorme ja pooltoodete vahendamine" },
    { v: "46441", l: "Portselani ja klaastoodete hulgimüük" },
    { v: "46442", l: "Puhastusvahendite hulgimüük" },
    { v: "46131", l: "Puidu ja ehitusmaterjalide hulgimüügi vahendusteenus" },
    { v: "46131", l: "Puidu ja ehitusmaterjalide vahendamine" },
    { v: "46731,46831", l: "Puidu ja puidu esmatöötlustoodete hulgimüük" },
    { v: "4673,4683", l: "Puidu, ehitusmaterjalide ja sanitaarseadmete hulgimüük" },
    { v: "4631,46311", l: "Puu- ja köögivilja hulgimüük" },
    { v: "4674,4684", l: "Rauakaupade, veevarustus- ja kütteseadmete ning nende koosteosade hulgimüük" },
    { v: "4646", l: "Ravimite ja meditsiinikaupade hulgimüük" },
    { v: "46461", l: "Ravimite ja muude apteegikaupade hulgimüük" },
    { v: "4642", l: "Rõivaste ja jalatsite hulgimüük" },
    { v: "46421", l: "Rõivaste ja rõivalisandite hulgimüük" },
    { v: "46832", l: "Sanitaarseadmete ja mujal liigitamata ehitusmaterjalide hulgimüük" },
    { v: "46732", l: "Sanitaarseadmete jm ehitusmaterjalide hulgimüük" },
    { v: "4690,46901", l: "Spetsialiseerimata hulgikaubandus" },
    { v: "46191", l: "Spetsialiseerimata hulgimüügi vahendusteenus" },
    { v: "46492", l: "Spordikaupade hulgimüük (v.a spordirõivad ja vabaajajalatsid)" },
    { v: "4636,46361", l: "Suhkru, šokolaadi ja suhkrukondiitritoodete hulgimüük" },
    { v: "46361", l: "Suhkru, šokolaadi, kondiitri- ja pagaritoodete hulgimüük" },
    { v: "4671,4681", l: "Tahke-, vedel- ja gaaskütuse jms toodete hulgimüük" },
    { v: "46711,46811", l: "Tahkekütuse hulgimüük" },
    { v: "46161", l: "Tekstiili, rõivaste, jalatsite ja nahktoodete hulgimüügi vahendusteenus" },
    { v: "46161", l: "Tekstiili, rõivaste, jalatsite ja nahktoodete vahendamine" },
    { v: "46641", l: "Tekstiilitööstus-, õmblus- ja kudumismasinate hulgimüük" },
    { v: "46211", l: "Teravilja, töötlemata tubaka, seemnete ja loomasööda hulgimüük" },
    { v: "46644,46693", l: "Toiduainetööstus- ja kaubandusseadmete hulgimüük" },
    { v: "46171", l: "Toidukaupade, jookide ja tubakatoodete hulgimüügi vahendusteenus" },
    { v: "46391", l: "Toidukaupade, jookide ja tubakatoodete spetsialiseerimata hulgimüük" },
    { v: "4617,46171", l: "Toidukaupade, jookide ja tubakatoodete vahendamine" },
    { v: "4662,46621", l: "Tööpinkide hulgimüük" },
    { v: "46241", l: "Toor- ja parknaha hulgimüük" },
    { v: "46749", l: "Tööriistade jm rauakaupade hulgimüük" },
    { v: "46691", l: "Tõste- ja teisaldusseadmete ja -masinate ning nende varuosade hulgimüük (k.a konteinerid)" },
    { v: "46642", l: "Tõste- ja teisaldusseadmete ja -masinate ning nende varuosade, k.a konteinerite hulgimüük" },
    { v: "46351", l: "Tubakatoodete hulgimüük" },
    { v: "46751,46851", l: "Väetise ja agrokeemiatoodete hulgimüük" },
    { v: "46741,46841", l: "Veevarustus- ja kütteseadmete ning nende koosteosade hulgimüük" },
  ],
  "47": [
    { v: "47621", l: "Ajalehtede ja kirjatarvete jaemüük spetsialiseeritud kauplustes" },
    { v: "47621", l: "Ajalehtede ja muu perioodika ning kirjatarvete jaemüük" },
    { v: "47791", l: "Antiikesemete jaemüük" },
    { v: "47791", l: "Antiikesemete jaemüük kauplustes" },
    { v: "4773,47731", l: "Apteekide tegevus" },
    { v: "47401", l: "Arvutite, arvuti välisseadmete ja tarkvara jaemüük" },
    { v: "47411", l: "Arvutite, arvuti välisseadmete ja tarkvara jaemüük spetsialiseeritud kauplustes" },
    { v: "47541", l: "Elektriliste kodumasinate jaemüük" },
    { v: "4754,47541", l: "Elektriliste kodumasinate jaemüük spetsialiseeritud kauplustes" },
    { v: "47782", l: "Foto- ja täppisseadmete jaemüük" },
    { v: "47782", l: "Fotokaupade jaemüük spetsialiseeritud kauplustes" },
    { v: "47403", l: "Heli- ja videoseadmete jaemüük" },
    { v: "47431", l: "Heli- ja videoseadmete jaemüük spetsialiseeritud kauplustes" },
    { v: "4740", l: "Info- ja sidetehnika jaemüük" },
    { v: "4719,47191", l: "Jaemüük muudes spetsialiseerimata kauplustes" },
    { v: "4791,47911", l: "Jaemüük posti või Interneti teel" },
    { v: "4711,47111", l: "Jaemüük spetsialiseerimata kauplustes, kus on ülekaalus toidukaubad, joogid ja tubakatooted" },
    { v: "47721", l: "Jalatsite ja nahktoodete jaemüük" },
    { v: "47721", l: "Jalatsite ja nahktoodete jaemüük spetsialiseeritud kauplustes" },
    { v: "47251", l: "Jookide jaemüük" },
    { v: "4725,47251", l: "Jookide jaemüük spetsialiseeritud kauplustes" },
    { v: "47231", l: "Kala, koorikloomade ja molluskite jaemüük" },
    { v: "47231", l: "Kala, vähilaadsete ja limuste jaemüük spetsialiseeritud kauplustes" },
    { v: "47521", l: "Käsi-tööriistade ja rauakaupade jaemüük" },
    { v: "4779", l: "Kasutatud kaupade jaemüük" },
    { v: "4779", l: "Kasutatud kaupade jaemüük kauplustes" },
    { v: "47792", l: "Kasutatud raamatute jaemüük" },
    { v: "47792", l: "Kasutatud raamatute jaemüük kauplustes" },
    { v: "47771", l: "Kellade ja ehete jaemüük" },
    { v: "4777,47771", l: "Kellade ja ehete jaemüük spetsialiseeritud kauplustes" },
    { v: "47751", l: "Kosmeetika ja tualetitarvete jaemüük" },
    { v: "4775,47751", l: "Kosmeetika ja tualetitarvete jaemüük spetsialiseeritud kauplustes" },
    { v: "47241", l: "Leiva- ja saiatoodete, kookide ja kondiitritoodete jaemüük" },
    { v: "47241", l: "Leivatoodete, kookide, jahu- ja suhkrukondiitritoodete jaemüük spetsialiseeritud kauplustes" },
    { v: "47762", l: "Lemmikloomade ja -lindude ning nende toidu ja tarvete jaemüük" },
    { v: "47762", l: "Lemmikloomade ja -lindude ning nende toidu ja tarvete jaemüük spetsialiseeritud kauplustes" },
    { v: "47221", l: "Liha ja lihatoodete jaemüük" },
    { v: "47221", l: "Liha ja lihatoodete jaemüük spetsialiseeritud kauplustes" },
    { v: "47761", l: "Lillede, taimede, seemnete ja istikute ning väetise jaemüük" },
    { v: "47761", l: "Lillede, taimede, seemnete ja istikute ning väetise jaemüük spetsialiseeritud kauplustes" },
    { v: "4776", l: "Lillede, taimede, seemnete, väetiste, lemmikloomade ja lemmikloomatoidu jaemüük spetsialiseeritud kauplustes" },
    { v: "4776", l: "Lillede, taimede, väetiste, lemmikloomade ja lemmikloomatoidu jaemüük" },
    { v: "47641", l: "Mängude ja mänguasjade jaemüük" },
    { v: "47651", l: "Mängude ja mänguasjade jaemüük spetsialiseeritud kauplustes" },
    { v: "4774,47741", l: "Meditsiini- ja ortopeediakaupade jaemüük" },
    { v: "47741", l: "Meditsiini- ja ortopeediakaupade jaemüük spetsialiseeritud kauplustes" },
    { v: "47783", l: "Meenete, kunstiesemete ja -tarvete jaemüük spetsialiseeritud kauplustes" },
    { v: "47551", l: "Mööbli ja valgustite jaemüük" },
    { v: "47591", l: "Mööbli ja valgustite jaemüük spetsialiseeritud kauplustes" },
    { v: "4759", l: "Mööbli, valgustite ja muude kodutarvete jaemüük spetsialiseeritud kauplustes" },
    { v: "4755", l: "Mööbli, valgustite, lauanõude ja muude kodutarvete jaemüük" },
    { v: "47301", l: "Mootorikütuse jaemüük" },
    { v: "47301", l: "Mootorikütuse jaemüük, sh tanklate tegevus" },
    { v: "47831", l: "Mootorrataste, nende osade ja lisaseadmete jaemüük" },
    { v: "47811", l: "Mootorsõidukite jaemüük" },
    { v: "47821", l: "Mootorsõidukite osade ja lisaseadmete jaemüük" },
    { v: "47789", l: "Mujal liigitamata kaupade jaemüük" },
    { v: "47789", l: "Mujal liigitamata kaupade jaemüük spetsialiseeritud kauplustes" },
    { v: "47691", l: "Mujal liigitamata kultuuri- ja vaba aja kaupade jaemüük" },
    { v: "4799,47991", l: "Muu jaemüük väljaspool kauplusi, kioskeid ja turge" },
    { v: "47121", l: "Muu spetsialiseerimata jaemüük" },
    { v: "47291", l: "Muu toidukaupade jaemüük spetsialiseeritud kauplustes" },
    { v: "47529", l: "Muude ehitusmaterjalide ja -tarvete jaemüük" },
    { v: "47529", l: "Muude ehitusmaterjalide ja -tarvete jaemüük spetsialiseeritud kauplustes" },
    { v: "47799", l: "Muude kasutatud kaupade jaemüük" },
    { v: "47799", l: "Muude kasutatud kaupade jaemüük kauplustes" },
    { v: "47891", l: "Muude kaupade jaemüük kioskites ja turgudel" },
    { v: "477", l: "Muude kaupade jaemüük spetsialiseeritud kauplustes" },
    { v: "47559", l: "Muude mujal liigitamata kodutarvete jaemüük" },
    { v: "47599", l: "Muude mujal liigitamata kodutarvete jaemüük spetsialiseeritud kauplustes" },
    { v: "47271", l: "Muude toidukaupade jaemüük" },
    { v: "4778", l: "Muude uute kaupade jaemüük" },
    { v: "4778", l: "Muude uute kaupade jaemüük spetsialiseeritud kauplustes" },
    { v: "47631", l: "Muusika- ja videosalvestiste jaemüük spetsialiseeritud kauplustes" },
    { v: "47781", l: "Optiliste seadmete jaemüük" },
    { v: "47111", l: "Peamiselt toidu, jookide või tubakatoodete spetsialiseerimata jaemüük" },
    { v: "47742", l: "Prillide jaemüük" },
    { v: "47781", l: "Prillide jm optikakaupade jaemüük spetsialiseeritud kauplustes" },
    { v: "47211", l: "Puu- ja köögivilja jaemüük" },
    { v: "47211", l: "Puu- ja köögivilja jaemüük spetsialiseeritud kauplustes" },
    { v: "47611", l: "Raamatute jaemüük" },
    { v: "4761,47611", l: "Raamatute jaemüük spetsialiseeritud kauplustes" },
    { v: "47521", l: "Rauakaupade ja tööriistade jaemüük spetsialiseeritud kauplustes" },
    { v: "4752", l: "Rauakaupade, ehitusmaterjalide, värvide ja klaasi jaemüük" },
    { v: "4752", l: "Rauakaupade, värvide ja klaasi jaemüük spetsialiseeritud kauplustes" },
    { v: "47731", l: "Ravimite jaemüük" },
    { v: "47711", l: "Rõivaste jaemüük" },
    { v: "4771,47711", l: "Rõivaste jaemüük spetsialiseeritud kauplustes" },
    { v: "47402", l: "Sideseadmete jaemüük" },
    { v: "47911", l: "Spetsialiseerimata jaemüügi vahendusteenus" },
    { v: "47921", l: "Spetsialiseeritud jaemüügi vahendusteenus" },
    { v: "47631", l: "Sporditarvete jaemüük" },
    { v: "4764,47641", l: "Sporditarvete jaemüük spetsialiseeritud kauplustes" },
    { v: "47783", l: "Suveniiride, käsitöö- ja religioossete esemete jaemüük" },
    { v: "4782,47821", l: "Tekstiili, rõivaste ja jalatsite jaemüük kioskites ja turgudel" },
    { v: "47511", l: "Tekstiilitoodete jaemüük" },
    { v: "4751,47511", l: "Tekstiiltoodete jaemüük spetsialiseeritud kauplustes" },
    { v: "47421", l: "Telekommunikatsiooniseadmete jaemüük spetsialiseeritud kauplustes" },
    { v: "4781,47811", l: "Toidukaupade, jookide ja tubakatoodete jaemüük kioskites ja turgudel" },
    { v: "47261", l: "Tubakatoodete jaemüük" },
    { v: "47261", l: "Tubakatoodete jaemüük spetsialiseeritud kauplustes" },
    { v: "47531", l: "Vaipade, mattide, seina- ja põrandakatete jaemüük" },
    { v: "47531", l: "Vaipade, mattide, seina-, põranda- ja aknakatete jaemüük spetsialiseeritud kauplustes" },
    { v: "47522", l: "Veevarustus- ja sanitaarseadmete ning nende koosteosade jaemüük" },
    { v: "47522", l: "Veevarustus- ja sanitaarseadmete ning nende koosteosade jaemüük spetsialiseeritud kauplustes" },
  ],
  "49": [
    { v: "49201", l: "Kauba raudteevedu" },
    { v: "4941,49411", l: "Kaubavedu maanteel" },
    { v: "4942,49421", l: "Kolimisteenused" },
    { v: "4931", l: "Sõitjate asulasisene ja linnalähitransport" },
    { v: "49321", l: "Sõitjate juhuvedu maanteel" },
    { v: "49312", l: "Sõitjate kaugliinivedu ja rahvusvaheline liinivedu" },
    { v: "4931", l: "Sõitjate liinivedu maanteel" },
    { v: "49391", l: "Sõitjate maakondadevaheline ja rahvusvaheline liinivedu" },
    { v: "49319", l: "Sõitjate muu kohalik liinivedu" },
    { v: "49319", l: "Sõitjate muu kohalik liinivedu (maakonna- ja vallasisesed liinid)" },
    { v: "49399", l: "Sõitjate muu maismaavedu" },
    { v: "4939,49391", l: "Sõitjate muu mujal liigitamata maismaavedu" },
    { v: "49101", l: "Sõitjate raudteevedu" },
    { v: "49331", l: "Sõitjate tellimusvedu koos juhiga" },
    { v: "49311", l: "Sõitjate vedu linna- ja linnalähiliinidel" },
    { v: "49341", l: "Sõitjatevedu köisteedel ja suusatõstukitega" },
    { v: "49111", l: "Sõitjatevedu raudteel" },
    { v: "4932,49321", l: "Taksovedu" },
    { v: "49501", l: "Torutransport" },
  ],
  "50": [
    { v: "5020,50201", l: "Kaubavedu merel ja rannavetes" },
    { v: "50401", l: "Kaubavedu sisevetel" },
    { v: "50202", l: "Laevade pukseerimine jms" },
    { v: "50101", l: "Sõitjate liinivedu merel ja rannavetes" },
    { v: "50102", l: "Sõitjate tellimusvedu merel ja rannavetes" },
    { v: "5010,50101", l: "Sõitjatevedu merel ja rannavetes" },
    { v: "50301", l: "Sõitjatevedu sisevetel" },
  ],
  "51": [
    { v: "51211", l: "Kauba õhutransport" },
    { v: "51221", l: "Kosmosetransport" },
    { v: "51101", l: "Sõitjate õhutransport" },
  ],
  "52": [
    { v: "52101", l: "Kaubaladude töö" },
    { v: "52311", l: "Kaubaveoga seotud vahendusteenus" },
    { v: "52241", l: "Laadungikäitlus" },
    { v: "5210", l: "Laondus" },
    { v: "52231", l: "Lennuväljade ja lennujaama reisiterminalide töö" },
    { v: "52251", l: "Logistikaalane tegevus" },
    { v: "5221", l: "Maismaaveondust teenindavad tegevusalad" },
    { v: "52292", l: "Mere-lastiveo organiseerimine, laevade agenteerimine" },
    { v: "52299", l: "Mujal liigitamata veondust abistavad tegevused" },
    { v: "52219", l: "Muud maismaaveondust teenindavad tegevusalad" },
    { v: "52269", l: "Muud mujal liigitamata veondust abistavad tegevusalad" },
    { v: "52239", l: "Muud õhutransporti teenindavad tegevusalad" },
    { v: "52229", l: "Muud veetransporti teenindavad tegevusalad" },
    { v: "5226", l: "Muud veondust abistavad tegevusalad" },
    { v: "5229", l: "Muud veondust abistavad tegevused" },
    { v: "5223", l: "Õhutransporti teenindavad tegevusalad" },
    { v: "52211", l: "Parklate tegevus" },
    { v: "52261", l: "Saadetiste organiseerimine ja ekspedeerimine" },
    { v: "52221", l: "Sadamate töö ja veeteede kasutamisega seotud tegevusalad" },
    { v: "52221", l: "Sadamate töö ja veeteede kasutamisega seotud tegevused" },
    { v: "52321", l: "Sõitjateveoga seotud vahendusteenus" },
    { v: "52293", l: "Tolliagentide tegevus" },
    { v: "52262", l: "Tollimaaklerite tegevus" },
    { v: "52102", l: "Vedelike ja gaaside ladustamine" },
    { v: "5222", l: "Veetransporti teenindavad tegevusalad" },
    { v: "52291", l: "Veoste ekspedeerimine" },
  ],
  "53": [
    { v: "5320", l: "Muu posti- ja kullerteenus" },
    { v: "53201", l: "Muu posti- ja kullerteenused" },
    { v: "53201", l: "Muud posti- ja kullerteenused" },
    { v: "53301", l: "Posti- ja kullerteenuste vahendusteenus" },
    { v: "53101", l: "Universaalne postiteenus" },
    { v: "53101", l: "Universaalne postiteenus " },
  ],
  "55": [
    { v: "55201", l: "Hostelid" },
    { v: "55101", l: "Hotellid" },
    { v: "5510", l: "Hotellid ja muu sarnane majutus" },
    { v: "55205", l: "Kodumajutus" },
    { v: "55205", l: "Kodumajutused" },
    { v: "55204", l: "Külaliskorter" },
    { v: "55204", l: "Külaliskorterid" },
    { v: "55103", l: "Külalistemajad" },
    { v: "55301", l: "Laagriplatsid ning vagunelamute ja haagissuvilate parkimisplatsid" },
    { v: "5530,55301", l: "Laagriplatsid, vagunelamute ja haagissuvilate parkimisplatsid" },
    { v: "55401", l: "Majutusega seotud vahendusteenus" },
    { v: "55102", l: "Motellid ja muu sarnane majutus" },
    { v: "55102", l: "Motellid jms majutus" },
    { v: "5590,55901", l: "Muu majutus" },
    { v: "55203", l: "Puhkeküla ja puhkelaager" },
    { v: "55203", l: "Puhkekülad ja puhkelaagrid" },
    { v: "55202", l: "Puhkemaja" },
    { v: "55202", l: "Puhkemajad" },
    { v: "5520", l: "Puhkuse- ja muu lühiajaline majutus" },
  ],
  "56": [
    { v: "5630,56301", l: "Jookide serveerimine" },
    { v: "56112", l: "Kiirsöögikohtade jm toitlustuskohtade tegevus" },
    { v: "56221", l: "Lepinguline toitlustusteenus jm toitlustamine" },
    { v: "56121", l: "Liikuvad toitlustuskohad" },
    { v: "5629,56291", l: "Muu toitlustamine" },
    { v: "5610", l: "Restoranid ja liikuvad toitlustuskohad" },
    { v: "56101", l: "Restoranid jm toitlustuskohad" },
    { v: "56111", l: "Restoranide ja kohvikute tegevus" },
    { v: "5611", l: "Restoranitegevus" },
    { v: "56401", l: "Toidu ja joogi serveerimise vahendusteenus" },
    { v: "5621,56211", l: "Toitlustamine üritustel" },
  ],
  "58": [
    { v: "58131,5814,58141", l: "Ajakirjade jm perioodika kirjastamine" },
    { v: "58121,58131", l: "Ajalehtede kirjastamine" },
    { v: "58211", l: "Arvutimängude kirjastamine" },
    { v: "58121", l: "Kataloogide ja aadressiraamatute kirjastamine" },
    { v: "58", l: "Kirjastamine" },
    { v: "58191", l: "Muu kirjastamine" },
    { v: "58191", l: "Muu kirjastamine, v.a tarkvara kirjastamine" },
    { v: "5829,58291", l: "Muu tarkvara kirjastamine" },
    { v: "58112", l: "Õpikute, sõnaraamatute jm teatmeteoste kirjastamine" },
    { v: "5811,58111", l: "Raamatukirjastamine" },
    { v: "5811", l: "Raamatute kirjastamine" },
    { v: "58111", l: "Raamatute, brošüüride jms väljaannete kirjastamine" },
    { v: "58211", l: "Videomängude kirjastamine" },
  ],
  "59": [
    { v: "5920,59201", l: "Helisalvestiste ja muusika kirjastamine" },
    { v: "5920", l: "Helisalvestiste tootmine ja muusika kirjastamine" },
    { v: "59201", l: "Helisalvestusteenus, k.a muusika salvestamine" },
    { v: "59131", l: "Kinofilmide ja videote levitamine" },
    { v: "59111", l: "Kinofilmide ja videote tootmine" },
    { v: "59141", l: "Kinofilmide linastamine" },
    { v: "5913,59131", l: "Kinofilmide, videote ja telesaadete levitamine" },
    { v: "5911", l: "Kinofilmide, videote ja telesaadete tootmine" },
    { v: "59121", l: "Kinofilmide, videote ja telesaadete tootmisjärgsed tegevusalad" },
    { v: "59209", l: "Muude helisalvestiste (v.a muusika) tootmine ja turustamine" },
    { v: "59202", l: "Muusika tootmine, turustamine ning muusika kirjastamine" },
    { v: "59112", l: "Telesaadete tootmine" },
  ],
  "60": [
    { v: "60202", l: "Kood ei ole enam kasutusel, vali kahe järgmise tegevusala koodi vahel: 61101 Elektroonilise side teenused fikseeritud sidevõrgus või 61301 Satelliitsideteenused (Kaabel-, satelliit- ja muud abonentprogrammid)  " },
    { v: "60391", l: "Muu sisu levitamine" },
    { v: "60101", l: "Raadioringhääling ja audiosisu levitamine" },
    { v: "6010,60101", l: "Raadioteenused" },
    { v: "6020,60201", l: "Televisiooniteenused ehk lineaarsed audiovisuaalmeedia teenused" },
    { v: "60201", l: "Televisiooniteenused ja videote levitamine" },
    { v: "60311", l: "Uudisteagentuuride tegevus" },
  ],
  "61": [
    { v: "61201", l: "Elektroonilise side edasimüük ja vahendusteenused" },
    { v: "6190,61901", l: "Elektroonilise side muud teenused" },
    { v: "6110,61101", l: "Elektroonilise side teenused fikseeritud sidevõrgus" },
    { v: "61101", l: "Elektroonilise side teenused fikseeritud või traadita sidevõrgus ja satelliitsideteenused" },
    { v: "6120,61201", l: "Elektroonilise side teenused traadita sidevõrgus" },
    { v: "61109", l: "Kood ei ole enam kasutusel, vali kahe järgmise tegevusala koodi vahel: 61101 Elektroonilise side teenused fikseeritud sidevõrgus või 61901 Elektroonilise side muud teenused (Muu traatsideteenuse osutamine)" },
    { v: "61209", l: "Kood ei ole enam kasutusel, vali kahe järgmise tegevusala koodi vahel: 61201 Elektroonilise side teenused traadita sidevõrgus või 61901 Elektroonilise side muud teenused (Muu traadita sideteenuse osutamine (sh traadita Internet))" },
    { v: "61901", l: "Muud elektroonilise side teenused" },
    { v: "61301", l: "Satelliitsideteenused" },
  ],
  "62": [
    { v: "62021,62201", l: "Arvutialased konsultatsioonid" },
    { v: "6220", l: "Arvutialased konsultatsioonid ning arvutisüsteemide ja andmebaaside haldus" },
    { v: "62031,62202", l: "Arvutisüsteemide ja andmebaaside haldus" },
    { v: "62091,62901", l: "Muud infotehnoloogia- ja arvutialased tegevused" },
    { v: "6201,62011,62101", l: "Programmeerimine" },
  ],
  "63": [
    { v: "63102", l: "Andmetöötlus, andmekorraldus, andmevahendus jms tegevus" },
    { v: "63111", l: "Andmetöötlus, veebihosting jms tegevused" },
    { v: "63101", l: "Andmetöötlustaristu, andmemajutus jms tegevus" },
    { v: "6310", l: "Andmetöötlustaristu, andmetöötlus, -majutus jms tegevus" },
    { v: "63991", l: "Mujal liigitamata infoalane tegevus" },
    { v: "63921", l: "Muu infoalane tegevus" },
    { v: "63911", l: "Uudisteagentuuride tegevus" },
    { v: "63911", l: "Veebiotsinguportaalide tegevus" },
    { v: "63121", l: "Veebiportaalide tegevus" },
  ],
  "64": [
    { v: "6430", l: "Investeerimine võlakirjadesse, väärtpaberitesse jms finantsvahenditesse" },
    { v: "6491,64911", l: "Kapitalirent" },
    { v: "64111", l: "Keskpanga tegevus" },
    { v: "64221", l: "Kontsernide finantsüksuste tegevus" },
    { v: "64191", l: "Krediidiasutused" },
    { v: "64191", l: "Krediidiasutused (pangad)" },
    { v: "6492", l: "Muu laenuandmine" },
    { v: "64929", l: "Muu laenuandmine, v.a pandimajad" },
    { v: "6419", l: "Muu rahaloomega seotud finantsvahendus" },
    { v: "64991", l: "Muud mujal liigitamata finantsteenused, v.a kindlustus ja pensionifondid" },
    { v: "6499,64991", l: "Muude mujal liigitamata finantsteenuste osutamine, v.a kindlustus ja pensionifondid" },
    { v: "64921", l: "Pandimajad" },
    { v: "64311", l: "Rahaturufondide ja muude investeerimisfondide tegevus" },
    { v: "64301", l: "Usaldusfondide, investeerimisfondide ja sarnaste finantsüksuste investeerimine võlakirjadesse, väärtpaberitesse jms finantsvahenditesse" },
    { v: "64321", l: "Usaldusühingute, päranditompude ja vahenduskontodega seotud tegevus" },
    { v: "6420,64201,64211", l: "Valdusfirmade tegevus" },
  ],
  "65": [
    { v: "65201", l: "Edasikindlustus" },
    { v: "65111", l: "Elukindlustus" },
    { v: "65121", l: "Kahjukindlustus" },
    { v: "6530,65301", l: "Pensionifondid" },
  ],
  "66": [
    { v: "66191", l: "Finantsnõustamine" },
    { v: "6611,66111", l: "Finantsturgude haldamine" },
    { v: "6630,66301", l: "Fondide valitsemine" },
    { v: "6622,66221", l: "Kindlustusagentide ja -vahendajate tegevus" },
    { v: "66221", l: "Kindlustusagentide tegevus" },
    { v: "66222", l: "Kindlustusmaaklerite tegevus" },
    { v: "66291", l: "Mujal liigitamata kindlustuse ja pensionifondide abitegevusalad" },
    { v: "6619", l: "Muud finantsteenuste abitegevusalad, v.a kindlustus ja pensionifondid" },
    { v: "6629,66291", l: "Muud kindlustuse ja pensionifondide abitegevusalad" },
    { v: "66199", l: "Muud mujal liigitamata finantsteenuste abitegevusalad" },
    { v: "66199", l: "Muud mujal liigitamata finantsteenuste abitegevusalad, v.a kindlustus ja pensionifondid" },
    { v: "66211", l: "Riskide ja kahju hindamine" },
    { v: "6612", l: "Väärtpaberi- ja kaubalepingute maaklerlus" },
    { v: "66121", l: "Väärtpaberite ja kaubalepingute maaklerlus" },
    { v: "66122,66129", l: "Valuutavahetus" },
  ],
  "68": [
    { v: "68322", l: "Aiandus- ja suvilaühistute haldus" },
    { v: "68322", l: "Aiandus- ja suvilaühistute jms haldus" },
    { v: "6810,68101,68111", l: "Enda kinnisvara ost ja müük" },
    { v: "6820,68201", l: "Enda või renditud kinnisvara üürileandmine ja käitus" },
    { v: "68121", l: "Hoonestusprojektide arendus" },
    { v: "68321", l: "Hoonete ja üürimajade haldus (korteriühistud, elamuühistud, hooneühistud jms)" },
    { v: "6832", l: "Kinnisvara haldus tasu eest või lepingu alusel" },
    { v: "68311", l: "Kinnisvarabüroode tegevus" },
    { v: "68311", l: "Kinnisvarateenuste vahendusteenus" },
    { v: "6832", l: "Muu kinnisvaraalane tegevus tasu eest või lepingu alusel" },
    { v: "68329", l: "Muu kinnisvarahaldus või haldusega seotud tegevused" },
  ],
  "69": [
    { v: "69101", l: "Advokaatide ja advokaadibüroode tegevus" },
    { v: "6920", l: "Arvepidamine, raamatupidamine ja auditeerimine; maksualane nõustamine" },
    { v: "69201", l: "Auditeerimine" },
    { v: "691,6910", l: "Juriidilised toimingud" },
    { v: "69109", l: "Muud juriidilised toimingud" },
    { v: "69103", l: "Notarite tegevus" },
    { v: "69102", l: "Õigusnõustajate ja õigusbüroode tegevus" },
    { v: "69202", l: "Raamatupidamine, maksualane nõustamine" },
  ],
  "70": [
    { v: "70201,7022", l: "Äri- ja muu juhtimisalane nõustamine" },
    { v: "70221", l: "Ärinõustamine jm juhtimisalane nõustamine" },
    { v: "70101", l: "Peakontorite tegevus" },
    { v: "70211", l: "Suhtekorraldus ja teabevahetus" },
  ],
  "71": [
    { v: "7111,71111", l: "Arhitektitegevused" },
    { v: "71201", l: "Autode tehniline ülevaatus" },
    { v: "71121", l: "Ehituslik insener-tehniline projekteerimine ja nõustamine" },
    { v: "71122", l: "Geoloogilised ja geodeetilised uurimistööd" },
    { v: "7112", l: "Inseneritegevused ning nendega seotud tehniline konsultatsioon" },
    { v: "7112", l: "Inseneritegevused ning nendega seotud tehniline nõustamine" },
    { v: "71209", l: "Muu tehniline katsetamine ja analüüs" },
    { v: "71209", l: "Muu teimimine ja analüüs" },
    { v: "71129", l: "Muud insener-tehnilised tegevusalad" },
    { v: "7120", l: "Tehniline katsetamine ja analüüs" },
    { v: "7120", l: "Teimimine ja analüüs" },
  ],
  "72": [
    { v: "7211,72111", l: "Teadus- ja arendustegevus biotehnoloogia vallas" },
    { v: "72101", l: "Teadus- ja arendustegevus loodus- ja tehnikateaduste vallas" },
    { v: "7219,72191", l: "Teadus- ja arendustegevus muude loodus- ja tehnikateaduste vallas" },
    { v: "7220,72201", l: "Teadus- ja arendustegevus sotsiaal- ja humanitaarteaduste vallas" },
  ],
  "73": [
    { v: "7312,73121", l: "Reklaami vahendamine meedias" },
    { v: "7311,73111", l: "Reklaamiagentuurid" },
    { v: "73111", l: "Reklaamiagentuuride tegevus" },
    { v: "73301", l: "Suhtekorraldus ja teabevahetus" },
    { v: "73201", l: "Turu-uuringud ja avaliku arvamuse küsitlused" },
  ],
  "74": [
    { v: "7410,74101", l: "Disainerite tegevus" },
    { v: "7420,74201", l: "Fotograafia" },
    { v: "74121", l: "Graafiline disain ja visuaalne kommunikatsioon" },
    { v: "74301", l: "Kirjalik ja suuline tõlge" },
    { v: "74991", l: "Kogu muu mujal liigitamata kutse-, teadus- ja tehnikaalane tegevus" },
    { v: "74141", l: "Muu disainerite tegevus" },
    { v: "7490,74901", l: "Muu mujal liigitamata kutse-, teadus- ja tehnikaalane tegevus" },
    { v: "74911", l: "Patentide vahendamine ja turundus" },
    { v: "74131", l: "Sisekujundus" },
    { v: "74111", l: "Tööstustoote- ja moedisain" },
  ],
  "75": [
    { v: "7500,75001", l: "Veterinaaria" },
  ],
  "77": [
    { v: "77511", l: "Autode, autoelamute ja haagiste rentimise ja kasutusrendi vahendusteenus" },
    { v: "7732,77321", l: "Ehitusmasinate ja -seadmete rentimine ja kasutusrent" },
    { v: "77401", l: "Intellektuaalomandi ja sarnaste toodete (v.a autoriõigusega tööd) rentimine" },
    { v: "77331", l: "Kontorimasinate ja -seadmete ning arvutite rentimine ja kasutusrent" },
    { v: "77331", l: "Kontorimasinate ja -seadmete rentimine ja kasutusrent, k.a arvutid" },
    { v: "7739", l: "Mujal liigitamata masinate, seadmete jm materiaalse vara rentimine ja kasutusrent" },
    { v: "77521", l: "Muu materiaalse ja immateriaalse vara (v.a finantsvara) rentimise ja kasutusrendi vahendusteenus" },
    { v: "77399", l: "Muu mujal liigitamata masinate, seadmete jm materiaalse vara rentimine ja kasutusrent" },
    { v: "7739", l: "Muude mujal liigitamata masinate, seadmete jm materiaalse vara rentimine ja kasutusrent" },
    { v: "77221,7729,77291", l: "Muude tarbeesemete ja kodumasinate väljaüürimine ja kasutusrent" },
    { v: "77351", l: "Õhutranspordivahendite rentimine ja kasutusrent" },
    { v: "77311", l: "Põllumajandusmasinate ja -seadmete rentimine ja kasutusrent" },
    { v: "77391", l: "Raudteeveeremi rentimine" },
    { v: "77391", l: "Raudteeveeremi rentimine ja kasutusrent" },
    { v: "7711,77111", l: "Sõiduautode ja väikebusside (täismassiga alla 3,5 t) rentimine ja kasutusrent" },
    { v: "77111", l: "Sõiduautode ja väikebusside (täismassiga kuni 3,5 t) rentimine ja kasutusrent" },
    { v: "7721,77211", l: "Vabaaja- ja sporditarvete väljaüürimine ja kasutusrent" },
    { v: "77341", l: "Veetranspordivahendite rentimine ja kasutusrent" },
    { v: "7712,77121", l: "Veokite rentimine ja kasutusrent" },
    { v: "77221", l: "Videokassettide ja DVD-de laenutamine" },
  ],
  "78": [
    { v: "7820,78201", l: "Ajutise tööjõu rent" },
    { v: "78301", l: "Muu inimressursiga varustamine" },
    { v: "78209", l: "Muud tööjõuteenused" },
    { v: "7810,78101", l: "Tööhõiveagentuuride tegevus" },
    { v: "78201", l: "Tööjõurent" },
    { v: "7820", l: "Tööjõurent ja muud tööjõuteenused" },
  ],
  "79": [
    { v: "79901", l: "Muu reisimisega seotud reserveerimine, sh giidide, piletiagentuuride ja turismiinfopunktide tegevus" },
    { v: "7990,79901", l: "Muu reserveerimine ja sellega seotud tegevus" },
    { v: "7911,79111", l: "Reisibüroode tegevus" },
    { v: "7912,79121", l: "Reisikorraldajate tegevus" },
  ],
  "80": [
    { v: "80301", l: "Juurdlus" },
    { v: "80011", l: "Juurdlus ja turvatöö, v.a avalik korrakaitse" },
    { v: "80091", l: "Mujal liigitamata turvatöö" },
    { v: "8020,80201", l: "Turvasüsteemide käitus" },
    { v: "8010,80101", l: "Turvatöö, v.a avalik korrakaitse" },
  ],
  "81": [
    { v: "8110,81101", l: "Hoonehalduse abitegevused" },
    { v: "81101", l: "Hoonehalduse kombineeritud teenus" },
    { v: "8122,81221", l: "Hoonete muu puhastus ja tööstuslik puhastustegevus" },
    { v: "8121,81211", l: "Hoonete üldpuhastus" },
    { v: "8130,81301", l: "Maastiku hooldus ja korrashoid" },
    { v: "81231,8129,81291", l: "Muu puhastustegevus" },
  ],
  "82": [
    { v: "82101", l: "Büroohaldus ja selle abitegevused" },
    { v: "82111", l: "Büroohaldus, kombineeritud sekretäriteenus" },
    { v: "82911", l: "Inkassoteenus ja krediidiinfo" },
    { v: "82201", l: "Kõnekeskuste tegevus" },
    { v: "82201", l: "Kõnekeskuste tegevus, telemarketing" },
    { v: "82301", l: "Konverentside ja messide korraldamine" },
    { v: "82401", l: "Mujal liigitamata äritegevust abistavate tegevuste vahendamine" },
    { v: "8299,82991", l: "Muud mujal liigitamata äritegevust abistavad tegevused" },
    { v: "8230,82301", l: "Nõupidamiste ja messide korraldamine" },
    { v: "82921", l: "Pakendamine" },
    { v: "8219,82191", l: "Valguskoopiad, dokumentide koostamine ja muud büroo abitegevused" },
  ],
  "84": [
    { v: "8424", l: "Avalik korrakaitse ja julgeolekuteenistused" },
    { v: "84123", l: "Elamu- ja kommunaalmajanduse haldus" },
    { v: "84123", l: "Elamu- ja kommunaalmajanduse korraldamine" },
    { v: "84121", l: "Hariduskorraldus" },
    { v: "84125", l: "Keskkonnakaitse korraldamine" },
    { v: "84231", l: "Kohtute tegevus ja haldus" },
    { v: "84301", l: "Kohustuslik sotsiaalkindlustus" },
    { v: "84113", l: "Majanduse ja sotsiaalse üldplaneerimisega ning statistikaga seotud tegevused" },
    { v: "84119", l: "Mujal liigitamata üldine avalik haldus" },
    { v: "84249", l: "Muud avaliku julgeoleku ja korrakaitsega seotud tegevused" },
    { v: "84139", l: "Muud majandustegevust toetavad tegevused" },
    { v: "84239", l: "Muud õiguskaitse ja kohtutega seotud tegevused, prokuratuuri tegevus" },
    { v: "84241", l: "Politseiteenistus" },
    { v: "84131", l: "Põllumajanduse, metsanduse, maakasutuse, kalanduse ja jahinduse haldus" },
    { v: "84112", l: "Rahandus- ja fiskaalpoliitikaga seotud tegevused" },
    { v: "84221", l: "Riigikaitse" },
    { v: "84111", l: "Täitev- ja seadusandlike organite tegevus" },
    { v: "84122", l: "Tervishoiu ja sotsiaalelu korraldus" },
    { v: "8412", l: "Tervishoiu-, haridus-, kultuuri- ja muude sotsiaalteenuste korraldamine" },
    { v: "84132", l: "Transpordi ja side haldus" },
    { v: "84251", l: "Tuletõrje- ja päästeteenistused, k.a vetelpääste" },
    { v: "84251", l: "Tuletõrje- ja päästeteenistused, vetelpääste, häirekeskused" },
    { v: "8411", l: "Üldine avalik haldus" },
    { v: "84124", l: "Vaba aja tegevuse, kultuuri ja religiooni haldus" },
    { v: "84211", l: "Välissuhted" },
    { v: "84114", l: "Valla- ja linnavalitsuste tegevus" },
    { v: "84232", l: "Vanglate ja parandusasutuste haldus" },
  ],
  "85": [
    { v: "8542", l: "Akadeemiline kõrgharidus" },
    { v: "85202", l: "Algkoolid" },
    { v: "85202", l: "Algkoolide tegevus" },
    { v: "8510", l: "Alusharidus" },
    { v: "85592", l: "Arvutiõpe" },
    { v: "8510", l: "Eelharidus" },
    { v: "8520", l: "Esimese taseme haridus" },
    { v: "85314", l: "Gümnaasiumid" },
    { v: "85313", l: "Gümnaasiumide tegevus" },
    { v: "85691", l: "Hariduse tugiteenused" },
    { v: "8560,85601", l: "Haridust abistavad tegevused" },
    { v: "8552", l: "Huvikoolitus" },
    { v: "85591", l: "Keeleõpe" },
    { v: "85331", l: "Keskharidusejärgne haridus, mida ei tunnustata kõrgharidusena" },
    { v: "8540", l: "Kõrgharidus" },
    { v: "8552", l: "Kunsti- ja kultuuriõpe" },
    { v: "85611", l: "Kursuste ja juhendajate vahendamine" },
    { v: "85321", l: "Kutseõppeasutused" },
    { v: "85321", l: "Kutseõppeasutuste tegevus" },
    { v: "85201", l: "Lasteaed-algkoolid" },
    { v: "85201", l: "Lasteaed-algkoolide tegevus" },
    { v: "85311", l: "Lasteaed-põhikoolid" },
    { v: "85102", l: "Lasteaedade tegevus" },
    { v: "85102", l: "Lasteaiad" },
    { v: "85101", l: "Lastehoiud" },
    { v: "85101", l: "Lastesõimede tegevus" },
    { v: "85593", l: "Loodus-, täppisteaduste ja tehnoloogia õpe" },
    { v: "8569", l: "Mujal liigitamata haridust abistavad tegevused" },
    { v: "8559", l: "Mujal liigitamata koolitus" },
    { v: "85529", l: "Muu huvikoolitus" },
    { v: "85529", l: "Muu kunsti- ja kultuuriõpe" },
    { v: "85599", l: "Muu mujal liigitamata koolitus" },
    { v: "8559,85599", l: "Muu mujal liigitamata õpe" },
    { v: "85519", l: "Muu spordi- ja vabaajakoolitus" },
    { v: "85519", l: "Muu spordiõpe" },
    { v: "85699", l: "Muud mujal liigitamata haridust abistavad tegevused" },
    { v: "85521", l: "Muusika- ja kunstikoolitus" },
    { v: "85521", l: "Muusika- ja kunstiõpe" },
    { v: "8520", l: "Põhihariduse I ja II kooliaste" },
    { v: "8531", l: "Põhihariduse III kooliaste ja üldkeskharidus" },
    { v: "85313", l: "Põhikool-gümnaasiumid" },
    { v: "85312", l: "Põhikoolid" },
    { v: "85312", l: "Põhikoolide tegevus" },
    { v: "85401", l: "Rakenduskõrgkoolid" },
    { v: "85411", l: "Rakenduskõrgkoolide tegevus" },
    { v: "8553,85531", l: "Sõiduõpe" },
    { v: "8551", l: "Spordi- ja vabaajakoolitus" },
    { v: "85511", l: "Spordikoolid" },
    { v: "8551", l: "Spordiõpe" },
    { v: "85522", l: "Tantsukoolide tegevus" },
    { v: "85522", l: "Tantsuõpe" },
    { v: "8532", l: "Teise taseme kutse- ja tehnikaharidus" },
    { v: "8531", l: "Teise taseme üldharidus" },
    { v: "85402", l: "Ülikoolid" },
    { v: "85421", l: "Ülikoolide tegevus" },
  ],
  "86": [
    { v: "86904,86942", l: "Ämmaemandate tegevus" },
    { v: "86906", l: "Diagnostikakabinettide ja -keskuste tegevus, nt röntgenlaborid, magnetresonants jms kabinetid" },
    { v: "8622,86221", l: "Eriarstiabi" },
    { v: "86221", l: "Eriarstiabi osutamine" },
    { v: "86101", l: "Haiglaravi" },
    { v: "86101", l: "Haiglaraviteenused" },
    { v: "8623,86231", l: "Hambaravi" },
    { v: "86231", l: "Hambaravi osutamine" },
    { v: "86901", l: "Kiirabi ja parameedikute tegevus" },
    { v: "86902", l: "Meditsiinilaborite, vere-, sperma- jms pankade tegevus" },
    { v: "86909", l: "Mujal liigitamata tervishoiualad" },
    { v: "8699,86992", l: "Muud mujal liigitamata tervishoiualad" },
    { v: "8690", l: "Muud tervishoiualad" },
    { v: "8694", l: "Õendus ja sünnitusabi" },
    { v: "86903,86941", l: "Õendusabi osutamine" },
    { v: "86921", l: "Patsiendi kiirabitransport" },
    { v: "86911", l: "Piltdiagnostika teenused ja meditsiinilaborite tegevus" },
    { v: "86931", l: "Psühholoogide ja psühhoterapeutide (v.a arstid) tegevus" },
    { v: "86971", l: "Ravi-, hambaravi- ja muude tervishoiuteenuste vahendamine" },
    { v: "86905", l: "Sanatooriumide ravitegevus" },
    { v: "86951", l: "Taastusravi" },
    { v: "86961", l: "Traditsiooniline, täiendav ja alternatiivmeditsiin" },
    { v: "8621,86211", l: "Üldarstiabi" },
    { v: "86211", l: "Üldarstiabi osutamine" },
    { v: "86991", l: "Vere-, sperma- jms pankade tegevus" },
  ],
  "87": [
    { v: "87202", l: "Ainesõltlaste hoolekandeasutuste tegevus" },
    { v: "87901", l: "Asendushooldusteenust  osutavate hoolekandeasutuste tegevus" },
    { v: "87991", l: "Asendushooldusteenust osutavate hoolekandeasutuste tegevus" },
    { v: "8720", l: "Diagnoositud või diagnoosimata psüühikahäirega isikute ning ainesõltlaste hoolekandeasutuste tegevus" },
    { v: "8730,87301", l: "Eakate või füüsilise puudega inimeste hoolekandeasutuste tegevus" },
    { v: "87101", l: "Hooldusraviasutuste tegevus" },
    { v: "87202", l: "Hoolekandeasutused ainesõltlastele" },
    { v: "87201", l: "Hoolekandeasutused intellektipuudega või psüühiliste erivajadustega isikutele" },
    { v: "87911", l: "Hoolekandeasutuste tegevuse vahendamine" },
    { v: "8790", l: "Muude hoolekandeasutuste tegevus" },
    { v: "87909,8799,87999", l: "Muude mujal liigitamata hoolekandeasutuste tegevus" },
    { v: "87201", l: "Vaimupuudega ja psüühiliste erivajadustega isikute hoolekandeasutuste tegevus" },
    { v: "8720", l: "Vaimupuudega ja psüühiliste erivajadustega isikute ning ainesõltlaste hoolekandeasutuste tegevus" },
    { v: "8730,87301", l: "Vanurite ja puuetega inimeste hoolekandeasutuste tegevus" },
  ],
  "88": [
    { v: "8810,88101", l: "Eakate ja puuetega inimeste sotsiaalhoolekanne majutuseta" },
    { v: "8891,88911", l: "Lapsehoiuteenus" },
    { v: "88991", l: "Mujal liigitamata sotsiaalhoolekanne ilma majutuseta" },
    { v: "8899,88991", l: "Mujal liigitamata sotsiaalhoolekanne majutuseta" },
    { v: "88101", l: "Vanurite ja puuetega inimeste sotsiaalhoolekanne majutuseta" },
  ],
  "90": [
    { v: "9020", l: "Esituskunstid" },
    { v: "90112", l: "Heliloome" },
    { v: "9011", l: "Kirjandus- ja heliloome" },
    { v: "90111", l: "Kirjandusloome" },
    { v: "90012", l: "Kontsertide lavastamine ja esitamine, muusikaline loometegevus jms tegevus" },
    { v: "90391", l: "Kunsti ja esituskunstide lavatehnilised abitegevused" },
    { v: "9003,90031", l: "Kunstialane loometegevus" },
    { v: "9001", l: "Lavakunst" },
    { v: "90021", l: "Lavakunsti abitegevused" },
    { v: "90131", l: "Muu kunstiloome" },
    { v: "9039", l: "Muud kunsti ja esituskunstide abitegevused" },
    { v: "90399", l: "Muud kunsti ja esituskunstide abitegevused, v.a lavatehnilised" },
    { v: "90209", l: "Muude esinejate lavaline tegevus" },
    { v: "90202", l: "Muusikute lavaline tegevus" },
    { v: "90201", l: "Näitlejate ja tantsijate lavaline tegevus" },
    { v: "90011", l: "Teatri- ja tantsuetenduste lavastamine ja esitamine" },
    { v: "90311", l: "Teatri-, kontserdi- jms hoonete ja objektide käitus" },
    { v: "90041", l: "Teatri-, kontserdi- jms hoonete käitus" },
    { v: "90121", l: "Visuaalkunstiloome" },
  ],
  "91": [
    { v: "91031", l: "Ajalooliste kohtade ja ehitiste jms vaatamisväärsuste käitus" },
    { v: "91221", l: "Ajalooliste paikade ja mälestistega seotud tegevus" },
    { v: "91012,91121", l: "Arhiivide tegevus" },
    { v: "9104", l: "Botaanika- ja loomaaedade ning looduskaitsealade tegevus" },
    { v: "91411", l: "Botaanika- ja loomaaedade tegevus" },
    { v: "91042", l: "Kaitsealade tegevus" },
    { v: "91301", l: "Kultuuripärandi säilitamine, taastamine ja muud säilitamise abitegevused" },
    { v: "91421", l: "Looduskaitsealade tegevus" },
    { v: "9121,91211", l: "Muuseumide ja kogudega seotud tegevus" },
    { v: "91021", l: "Muuseumide tegevus" },
    { v: "9101", l: "Raamatukogude ja arhiivide tegevus" },
    { v: "91011,9111,91111", l: "Raamatukogude tegevus" },
  ],
  "92": [
    { v: "92001", l: "Hasartmängude ja kihlvedude korraldamine" },
  ],
  "93": [
    { v: "9313,93131", l: "Aeroobika- ja jõusaalide tegevus" },
    { v: "93122", l: "Invaspordiklubide tegevus" },
    { v: "93291", l: "Kultuurikeskused ja rahvamajad" },
    { v: "93211", l: "Lõbustus- ja teemaparkide tegevus" },
    { v: "93211", l: "Lõbustusparkide ja temaatiliste lõbustusparkide tegevus" },
    { v: "93291", l: "Mujal liigitamata lõbustus- ja vaba aja tegevused" },
    { v: "9319,93199", l: "Mujal liigitamata sporditegevus" },
    { v: "9319", l: "Muu sporditegevus" },
    { v: "9329", l: "Muud lõbustus- ja vaba aja tegevused" },
    { v: "93299", l: "Muud mujal liigitamata lõbustus- ja vaba aja tegevused" },
    { v: "93191", l: "Spordi alaliitude, spordiliitude ja spordiühenduste tegevus" },
    { v: "93131", l: "Spordi- ja jõusaalide tegevus" },
    { v: "93111", l: "Spordiehitiste käitus" },
    { v: "9312,93121", l: "Spordiklubide tegevus" },
    { v: "93111", l: "Spordirajatiste käitus" },
    { v: "93192", l: "Sportlik ja meelelahutuslik jahipidamine ja kalapüük" },
  ],
  "94": [
    { v: "94201", l: "Ametiühingute tegevus" },
    { v: "94921", l: "Erakondade tegevus" },
    { v: "9411", l: "Ettevõtjate ja tööandjate organisatsioonide tegevus" },
    { v: "94996", l: "Keskkonna- ja looduskaitseühendused" },
    { v: "94911", l: "Kirikute, koguduste ja kloostrite tegevus" },
    { v: "94991", l: "Kodanikuõiguste kaitse ja eestkoste; teatud elanikegrupi huvide kaitse" },
    { v: "9412", l: "Kutseorganisatsioonide tegevus" },
    { v: "94121", l: "Loomeliitude tegevus" },
    { v: "9499", l: "Mujal liigitamata organisatsioonide tegevus" },
    { v: "94119", l: "Muude ettevõtjate ja tööandjate organisatsioonide tegevus" },
    { v: "94129", l: "Muude kutseorganisatsioonide tegevus" },
    { v: "94999", l: "Muude mujal liigitamata organisatsioonide tegevus" },
    { v: "94929", l: "Muude poliitiliste organisatsioonide tegevus" },
    { v: "94919", l: "Muude usuorganisatsioonide tegevus" },
    { v: "94993", l: "Noorte- ja lasteühendused ning noorte ja laste heaolu edendavad ühendused" },
    { v: "94992", l: "Piirkondlikku/kohalikku elu edendavad ja toetavad ühendused" },
    { v: "94992", l: "Piirkondlikku/kohalikku elu edendavad ja toetavad ühendused ja fondid" },
    { v: "9492", l: "Poliitiliste organisatsioonide tegevus" },
    { v: "94111", l: "Põllumajandusseltsid ja -liidud, aiandus- ja mesindusseltsid, metsaseltsid ja -liidud" },
    { v: "94994", l: "Rahvusvähemuste ühendused ja kultuuriseltsid" },
    { v: "94994", l: "Rahvusvähemuste ühendused ja kultuuriseltsid, rahvuste vahelist austust ja sõprust edendavad ühendused" },
    { v: "94997", l: "Tervisehäiretega isikute ühendused ja nende liidud; puuetega inimeste ühendused ja nende liidud, erivajadustega inimeste kaitseühendused" },
    { v: "94997", l: "Tervisehäiretega, puuetega või erivajadustega isikute ühendused ja nende liidud" },
    { v: "9491", l: "Usuorganisatsioonide tegevus" },
    { v: "94995", l: "Vaba aja veetmise, meelelahutuse ja kultuurilise tegevusega või huvialadega seotud ühendused ning huviklubid" },
    { v: "94995", l: "Vaba aja veetmise, meelelahutuse, kultuurilise tegevuse või huvialadega seotud ühendused" },
  ],
  "95": [
    { v: "9511,95111", l: "Arvutite ja arvuti välisseadmete parandus" },
    { v: "95101", l: "Arvutite ja arvuti välisseadmete parandus ja hooldus" },
    { v: "9510", l: "Arvutite ja sideseadmete parandus ja hooldus" },
    { v: "95401", l: "Arvutite, tarbeesemete ja kodutarvete ning mootorsõidukite ja mootorrataste paranduse ja hoolduse vahendamine" },
    { v: "95231", l: "Jalatsite ja nahktoodete parandus" },
    { v: "95231", l: "Jalatsite ja nahktoodete parandus ning hooldus" },
    { v: "95251", l: "Kellade ja ehete parandus" },
    { v: "95251", l: "Kellade ja ehete parandus ning hooldus" },
    { v: "9522,95221", l: "Kodumasinate ning majapidamis- ja aiatööriistade parandus" },
    { v: "95221", l: "Kodumasinate ning majapidamis- ja aiatööriistade parandus ning hooldus" },
    { v: "9524,95241", l: "Mööbli ja sisustusesemete parandus" },
    { v: "95241", l: "Mööbli ja sisustusesemete parandus ning hooldus" },
    { v: "95321", l: "Mootorrataste remont ja hooldus" },
    { v: "95311", l: "Mootorsõidukite remont ja hooldus" },
    { v: "95291", l: "Mujal liigitamata tarbeesemete ja kodutarvete parandus ning hooldus" },
    { v: "9529,95291", l: "Muude tarbeesemete ja kodutarvete parandus" },
    { v: "95121", l: "Sideseadmete parandus" },
    { v: "95102", l: "Sideseadmete parandus ja hooldus" },
    { v: "95211", l: "Tarbeelektroonika parandus" },
    { v: "95211", l: "Tarbeelektroonika parandus ja hooldus" },
  ],
  "96": [
    { v: "9604", l: "Füüsilise heaoluga seotud teenindus" },
    { v: "9622", l: "Iluhooldus ja muud iluteenused" },
    { v: "9602,96021", l: "Juuksuri- ja muu iluteenindus" },
    { v: "96211", l: "Juuksuriteenindus ja habemeajamine" },
    { v: "96032", l: "Kalmistute ja krematooriumite tegevus" },
    { v: "96302", l: "Kalmistute tegevus" },
    { v: "96911", l: "Koduteenindus" },
    { v: "96221", l: "Kosmeetiku iluhooldusteenused" },
    { v: "96222", l: "Küünetehnikuteenused" },
    { v: "96091,96991", l: "Lemmikloomade hooldamine" },
    { v: "96301", l: "Matusebüroode ja krematooriumide tegevus" },
    { v: "96031", l: "Matusetalituste korraldamine" },
    { v: "9603,9630", l: "Matuseteenindus" },
    { v: "9609,9699,96999", l: "Muu mujal liigitamata teenindus" },
    { v: "96099", l: "Muu teenindus" },
    { v: "96229", l: "Muud iluhooldused ja iluteenused" },
    { v: "96231", l: "Päevaspaa, massaažisalongide ja saunade tegevus" },
    { v: "9623", l: "Päevaspaa, saunade ja aurusaunade tegevus" },
    { v: "96224", l: "Püsimeigiteenused" },
    { v: "96223", l: "Ripsme- ja kulmutehnikuteenused" },
    { v: "96041", l: "Saunade, solaariumite ja massaažisalongide tegevus jm füüsilise heaoluga seotud teenindus" },
    { v: "96232", l: "Solaariumide tegevus" },
    { v: "96401", l: "Teeninduse vahendamine" },
    { v: "9601,96011", l: "Tekstiil- ja karusnahatoodete pesu ja keemiline puhastus" },
    { v: "96101", l: "Tekstiil- ja karusnahatoodete pesu ja puhastus" },
  ],
  "98": [
    { v: "98101", l: "Kodumajapidamiste oma tarbeks mõeldud eristamata kaupade tootmine" },
    { v: "9820,98201", l: "Kodumajapidamiste oma tarbeks mõeldud eristamata teenuste osutamine" },
  ],
  "99": [
    { v: "9900", l: "Eksterritoriaalsete organisatsioonide ja üksuste tegevus" },
  ],
};
